// @ts-nocheck
import * as z from 'zod';

import {
  type AlarmDefinition,
  type AllocatedInjectionStringAgent,
  type AllocatedPropertiesString,
  type AllocatedRatesDailyStringAgent,
  type AllocatedRatesRealtimeStringAgent,
  type AllocatedRatesVfmStringAgent,
  type AllocationFactorsFieldAgent,
  type AllocationOutputString,
  type AsphalteneCurve,
  type Asset,
  type ChokeCurveInfo,
  Cognite3DGroupGroupType,
  type Cognite3DModel,
  Cognite3DModelType,
  type Cognite3DObject,
  type Cognite3DRevision,
  Cognite3DRevisionStatus,
  Cognite3DRevisionType,
  type Cognite3DTransformation,
  type Cognite360Image,
  type Cognite360ImageAnnotation,
  type Cognite360ImageCollection,
  type Cognite360ImageModel,
  type Cognite360ImageStation,
  type CogniteActivity,
  type CogniteAnnotation,
  CogniteAnnotationStatus,
  type CogniteAsset,
  type CogniteAssetClass,
  type CogniteAssetType,
  type CogniteCadModel,
  type CogniteCadNode,
  type CogniteCadRevision,
  type CogniteCubeMap,
  type CogniteDescribable,
  type CogniteDiagramAnnotation,
  type CogniteEquipment,
  type CogniteEquipmentType,
  type CogniteFile,
  type CogniteFileCategory,
  type CogniteMaintenanceOrder,
  type CogniteNotification,
  type CogniteOperation,
  type CognitePointCloudModel,
  type CognitePointCloudRevision,
  type CognitePointCloudVolume,
  CognitePointCloudVolumeVolumeType,
  type CogniteSchedulable,
  type CogniteSourceable,
  type CogniteSourceSystem,
  type CogniteTimeSeries,
  CogniteTimeSeriesType,
  type CogniteUnit,
  type CogniteVisualizable,
  type Company,
  type DailyRollupFieldAgent,
  type DailyRollupOutputAsset,
  type DailyRollupOutputCompany,
  type DailyRollupOutputField,
  type DailyRollupOutputLocation,
  type DailyRollupOutputReservoir,
  type DailyRollupOutputWell,
  type DataDrivenRatesStringAgent,
  type DataMapping,
  type Entity,
  type EntityAgent,
  type EspAlarmsAgent,
  type EspCable,
  type EspCalculationsStringAgent,
  type EspLimitsStringAgent,
  type EspMeasurementsStringAgent,
  type EspMotor,
  type EspPump,
  type EspPumpDetails,
  type EstimatedRatesStringAgent,
  type EventsString,
  type Field,
  type FieldFormation,
  type FieldInputs,
  type FieldOutputs,
  type FlatHierarchy,
  type FlatHierarchyAgent,
  type FlowAssuranceAlarmsAgent,
  type FlowlineOutputsNetworkAgent,
  type FluidComposition,
  type FormationVolumeFactor,
  type GasLiftAlarmsAgent,
  type GasLiftCalculationsStringAgent,
  type GasLiftLimitsStringAgent,
  type GasLiftMeasurementsStringAgent,
  type GlValveData,
  type InactiveString,
  type InactiveStringAgent,
  type InjectionAlarmsAgent,
  type InjectionAllocationFactor,
  type InjectionPerformanceStringAgent,
  type InjPressGuidelineString,
  type InjPressGuidelineStringAgent,
  type LiftTypeParameterString,
  type Location,
  type LocationInputs,
  type ManifoldInputs,
  type MapGridMapping,
  type MeasuredInjectionStringAgent,
  type MeasuredRatesWellTestStringAgent,
  type ModelManagementAlarmsAgent,
  type ModelMatchedRatesStringAgent,
  type Mpfm,
  type MpfmInputs,
  type MpfmOutputs,
  type MpfmWellTestOutputs,
  type Network,
  type NetworkInputs,
  type NetworkModel,
  type NetworkOutputsField,
  type NetworkOutputsString,
  type NetworkRatesStringAgent,
  type NetworkRiskAgent,
  type NetworkRiskOptimizationScenarios,
  type NetworkRiskOptimizationScenariosAgent,
  type OpportunityAgent,
  type OptimizedRatesNetworkStringAgent,
  type OptimizedRatesSrmStringAgent,
  type PriorityRatesStringAgent,
  type ProdplanString,
  type ProdplanStringReservoirSector,
  type ProducerGuidelinesStringAgent,
  type ProductionAllocationAlarmsAgent,
  type ProsperModel,
  type ProsperModelAgent,
  type ProsperModelEventLog,
  type ProsperModelMetrics,
  type PseudoPressureTable,
  type PtsOutputsString,
  type PtsOutputsStringAgent,
  type PtsReferenceConditions,
  type PvtAnalysisString,
  type PvtAnalysisStringAgent,
  type RateDiagnosticsStringAgent,
  type Reservoir,
  type ReservoirGuideline,
  type ReservoirInputs,
  type ReservoirInputsAgent,
  type ReservoirOutputs,
  type ReservoirOutputsAgent,
  type ReservoirProdplan,
  type SaturationPressureMapping,
  type Sector,
  type SectorHierarchy,
  type SectorHierarchyAgent,
  type SectorOutputs,
  type SectorProdplan,
  type SeparatorInputs,
  type ShgProducerGuideline,
  type SPressSettings,
  type SrmOutput,
  type SrmOutputsAllEntities,
  type SrmOutputsString,
  type SrmSettings,
  type StringAsset,
  type StringFluidComposition,
  type StringFluidCompositionAgent,
  type StringFunction,
  type StringInputsStatic,
  type StringReservoirInputs,
  type SurveillanceAlarmsAgent,
  type TicketRegistryAgent,
  type TimeSeries,
  type WaterAnalysis,
  type Well,
  type WellBehaviourAlarmsAgent,
  type WellChokeMapping,
  type WellInputsStatic,
  type WellInputsString,
  type WellMovementAgent,
  type WellOutputsExt_1String,
  type WellOutputsString,
  type WellStatusStringAgent,
  type WellTestAnalysisAgent,
  type WellTestGaugeString,
  type WellTestInputsString,
  type WellTestModelParametersAgent,
  type WellTestOutputsString,
  type WellTestRaw,
  type WellTestReservoirAnalysisAgent,
  type Wf3OutputsString,
  type Wf05FieldOutputs,
  type Wf05StringOutputs,
  type Wf05StringReservoirOutputs,
  type WfAlarms,
  type WfAlarmsAgent,
  type WfFieldAlarms,
  type WfReservoirAlarms,
  type WfSectorAlarms,
  type WfStringAlarms,
  type WfWellAlarms,
} from './graphql/graphql.ts';

type Properties<T> = {
  [K in keyof T]: z.ZodType<T[K], T[K] | undefined>;
};

type definedNonNullAny = {};

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny => v !== undefined && v !== null;

export const definedNonNullAnySchema = z.any().refine((v) => isDefinedNonNullAny(v));

export const CogniteTimeSeriesTypeSchema: z.ZodType<CogniteTimeSeriesType, CogniteTimeSeriesType> =
  z.enum(CogniteTimeSeriesType);

export const CognitePointCloudVolumeVolumeTypeSchema: z.ZodType<
  CognitePointCloudVolumeVolumeType,
  CognitePointCloudVolumeVolumeType
> = z.enum(CognitePointCloudVolumeVolumeType);

export const CogniteAnnotationStatusSchema: z.ZodType<CogniteAnnotationStatus, CogniteAnnotationStatus> =
  z.enum(CogniteAnnotationStatus);

export const Cognite3DRevisionTypeSchema: z.ZodType<Cognite3DRevisionType, Cognite3DRevisionType> =
  z.enum(Cognite3DRevisionType);

export const Cognite3DRevisionStatusSchema: z.ZodType<Cognite3DRevisionStatus, Cognite3DRevisionStatus> =
  z.enum(Cognite3DRevisionStatus);

export const Cognite3DModelTypeSchema: z.ZodType<Cognite3DModelType, Cognite3DModelType> = z.enum(Cognite3DModelType);

export const Cognite3DGroupGroupTypeSchema: z.ZodType<Cognite3DGroupGroupType, Cognite3DGroupGroupType> =
  z.enum(Cognite3DGroupGroupType);

export const CogniteUnitSchema: z.ZodObject<Properties<CogniteUnit>> = z.object({
  __typename: z.literal('CogniteUnit').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  description: z.string().nullish(),
  name: z.string().nullish(),
  quantity: z.string().nullish(),
  source: z.string().nullish(),
  sourceReference: z.string().nullish(),
  symbol: z.string().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
});

export const CogniteFileCategorySchema: z.ZodObject<Properties<CogniteFileCategory>> = z.object({
  __typename: z.literal('CogniteFileCategory').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  code: z.string(),
  description: z.string().nullish(),
  name: z.string().nullish(),
  standard: z.string().nullish(),
  standardReference: z.string().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
});

export const CogniteEquipmentTypeSchema: z.ZodObject<Properties<CogniteEquipmentType>> = z.object({
  __typename: z.literal('CogniteEquipmentType').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  code: z.string().nullish(),
  description: z.string().nullish(),
  equipmentClass: z.string().nullish(),
  name: z.string().nullish(),
  standard: z.string().nullish(),
  standardReference: z.string().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
});

export const CogniteDescribableSchema: z.ZodObject<Properties<CogniteDescribable>> = z.object({
  aliases: z.array(z.string().nullable()).nullish(),
  description: z.string().nullish(),
  name: z.string().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
});

export const EspPumpSchema: z.ZodObject<Properties<EspPump>> = z.object({
  __typename: z.literal('ESPPump').optional(),
  description: z.string().nullish(),
  frequency: z.number().nullish(),
  manufacturer: z.string().nullish(),
  maximumRate: z.number().nullish(),
  minimumRate: z.number().nullish(),
  name: z.string().nullish(),
  prosperIndex: z.int64().nullish(),
  pumpSize: z.number().nullish(),
  stages: z.number().nullish(),
});

export const EspMotorSchema: z.ZodObject<Properties<EspMotor>> = z.object({
  __typename: z.literal('ESPMotor').optional(),
  current: z.number().nullish(),
  description: z.string().nullish(),
  manufacturer: z.string().nullish(),
  motorSeries: z.string().nullish(),
  power: z.number().nullish(),
  prosperIndex: z.int64().nullish(),
  voltage: z.number().nullish(),
});

export const EspCableSchema: z.ZodObject<Properties<EspCable>> = z.object({
  __typename: z.literal('ESPCable').optional(),
  cableType: z.string().nullish(),
  description: z.string().nullish(),
  maxCurrentAllowed: z.number().nullish(),
  prosperIndex: z.int64().nullish(),
  voltageDropCoefficient: z.number().nullish(),
});

export const CogniteAssetClassSchema: z.ZodObject<Properties<CogniteAssetClass>> = z.object({
  __typename: z.literal('CogniteAssetClass').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  code: z.string().nullish(),
  description: z.string().nullish(),
  name: z.string().nullish(),
  standard: z.string().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
});

export const CogniteAssetTypeSchema: z.ZodObject<Properties<CogniteAssetType>> = z.object({
  __typename: z.literal('CogniteAssetType').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  assetClass: z.lazy(() => CogniteAssetClassSchema.nullish()),
  code: z.string().nullish(),
  description: z.string().nullish(),
  name: z.string().nullish(),
  standard: z.string().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
});

export const CogniteSourceSystemSchema: z.ZodObject<Properties<CogniteSourceSystem>> = z.object({
  __typename: z.literal('CogniteSourceSystem').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  description: z.string().nullish(),
  manufacturer: z.string().nullish(),
  name: z.string().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  version: z.string().nullish(),
});

export const Cognite3DTransformationSchema: z.ZodObject<Properties<Cognite3DTransformation>> = z.object({
  eulerRotationX: z.number().nullish(),
  eulerRotationY: z.number().nullish(),
  eulerRotationZ: z.number().nullish(),
  scaleX: z.number().nullish(),
  scaleY: z.number().nullish(),
  scaleZ: z.number().nullish(),
  translationX: z.number().nullish(),
  translationY: z.number().nullish(),
  translationZ: z.number().nullish(),
});

export const Cognite360ImageStationSchema: z.ZodObject<Properties<Cognite360ImageStation>> = z.object({
  __typename: z.literal('Cognite360ImageStation').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  description: z.string().nullish(),
  groupType: Cognite3DGroupGroupTypeSchema.nullish(),
  name: z.string().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
});

export const WellSchema: z.ZodObject<Properties<Well>> = z.object({
  __typename: z.literal('Well').optional(),
  endDateTime: z.coerce.date().nullish(),
  entityType: z.string().nullish(),
  name: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
});

export const WfWellAlarmsSchema: z.ZodObject<Properties<WfWellAlarms>> = z.object({
  __typename: z.literal('WfWellAlarms').optional(),
  alarmCounter: z.number().nullish(),
  alarmFlags: z.string().nullish(),
  alarmLevel: z.string().nullish(),
  alarmMessage: z.string().nullish(),
  alarmName: z.string().nullish(),
  alarmType: z.string().nullish(),
  configuration: z.string().nullish(),
  endDateTime: z.coerce.date().nullish(),
  entityName: z.lazy(() => WellSchema.nullish()),
  operationType: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
  ticketId: z.string().nullish(),
  workflowName: z.string().nullish(),
});

export const TicketRegistryAgentSchema: z.ZodObject<Properties<TicketRegistryAgent>> = z.object({
  __typename: z.literal('TicketRegistry_Agent').optional(),
  actionPlan: z.string().nullish(),
  assignedTo: z.string().nullish(),
  closedDate: z.coerce.date().nullish(),
  description: z.string().nullish(),
  dueDate: z.coerce.date().nullish(),
  entityName: z.string().nullish(),
  entityType: z.string().nullish(),
  isOpportunity: z.string().nullish(),
  priority: z.string(),
  recommendation: z.string().nullish(),
  reportedDate: z.coerce.date(),
  status: z.string(),
  ticketCategory: z.string().nullish(),
  ticketId: z.string(),
  ticketSource: z.string().nullish(),
  ticketSummary: z.string(),
});

export const StringFunctionSchema: z.ZodObject<Properties<StringFunction>> = z.object({
  __typename: z.literal('String_Function').optional(),
  endDate: z.coerce.date().nullish(),
  fieldCode: z.string().nullish(),
  primaryWellbore: z.string().nullish(),
  startDate: z.coerce.date().nullish(),
  string: z.string().nullish(),
  stringCode: z.string().nullish(),
  stringFunction: z.string().nullish(),
  well: z.string().nullish(),
});

export const SectorSchema: z.ZodObject<Properties<Sector>> = z.object({
  __typename: z.literal('Sector').optional(),
  endDateTime: z.coerce.date().nullish(),
  entityType: z.string().nullish(),
  name: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
});

export const WfSectorAlarmsSchema: z.ZodObject<Properties<WfSectorAlarms>> = z.object({
  __typename: z.literal('WfSectorAlarms').optional(),
  alarmCounter: z.number().nullish(),
  alarmFlags: z.string().nullish(),
  alarmLevel: z.string().nullish(),
  alarmMessage: z.string().nullish(),
  alarmName: z.string().nullish(),
  alarmType: z.string().nullish(),
  configuration: z.string().nullish(),
  endDateTime: z.coerce.date().nullish(),
  entityName: z.lazy(() => SectorSchema.nullish()),
  operationType: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
  ticketId: z.string().nullish(),
  workflowName: z.string().nullish(),
});

export const ReservoirSchema: z.ZodObject<Properties<Reservoir>> = z.object({
  __typename: z.literal('Reservoir').optional(),
  endDateTime: z.coerce.date().nullish(),
  entityType: z.string().nullish(),
  name: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
});

export const WfReservoirAlarmsSchema: z.ZodObject<Properties<WfReservoirAlarms>> = z.object({
  __typename: z.literal('WfReservoirAlarms').optional(),
  alarmCounter: z.number().nullish(),
  alarmFlags: z.string().nullish(),
  alarmLevel: z.string().nullish(),
  alarmMessage: z.string().nullish(),
  alarmName: z.string().nullish(),
  alarmType: z.string().nullish(),
  configuration: z.string().nullish(),
  endDateTime: z.coerce.date().nullish(),
  entityName: z.lazy(() => ReservoirSchema.nullish()),
  operationType: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
  ticketId: z.string().nullish(),
  workflowName: z.string().nullish(),
});

export const LocationSchema: z.ZodObject<Properties<Location>> = z.object({
  __typename: z.literal('Location').optional(),
  endDateTime: z.coerce.date().nullish(),
  entityType: z.string().nullish(),
  name: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
});

export const MpfmSchema: z.ZodObject<Properties<Mpfm>> = z.object({
  __typename: z.literal('Mpfm').optional(),
  endDateTime: z.coerce.date().nullish(),
  entityType: z.string().nullish(),
  location: z.lazy(() => LocationSchema.nullish()),
  modelName: z.string().nullish(),
  name: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
});

export const EntityAgentSchema: z.ZodObject<Properties<EntityAgent>> = z.object({
  __typename: z.literal('Entity_Agent').optional(),
  endDateTime: z.coerce.date().nullish(),
  entityType: z.string().nullish(),
  name: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
});

export const EntitySchema: z.ZodObject<Properties<Entity>> = z.object({
  __typename: z.literal('Entity').optional(),
  endDateTime: z.coerce.date().nullish(),
  entityType: z.string().nullish(),
  name: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
});

export const CompanySchema: z.ZodObject<Properties<Company>> = z.object({
  __typename: z.literal('Company').optional(),
  endDateTime: z.coerce.date().nullish(),
  entityType: z.string().nullish(),
  name: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
});

export const CogniteSourceableSchema: z.ZodObject<Properties<CogniteSourceable>> = z.object({
  source: z.lazy(() => CogniteSourceSystemSchema.nullish()),
  sourceContext: z.string().nullish(),
  sourceCreatedTime: z.coerce.date().nullish(),
  sourceCreatedUser: z.string().nullish(),
  sourceId: z.string().nullish(),
  sourceUpdatedTime: z.coerce.date().nullish(),
  sourceUpdatedUser: z.string().nullish(),
});

export const CogniteSchedulableSchema: z.ZodObject<Properties<CogniteSchedulable>> = z.object({
  endTime: z.coerce.date().nullish(),
  scheduledEndTime: z.coerce.date().nullish(),
  scheduledStartTime: z.coerce.date().nullish(),
  startTime: z.coerce.date().nullish(),
});

export const CogniteDiagramAnnotationSchema: z.ZodObject<Properties<CogniteDiagramAnnotation>> = z.object({
  __typename: z.literal('CogniteDiagramAnnotation').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  confidence: z.number().nullish(),
  description: z.string().nullish(),
  endNodePageNumber: z.int64().nullish(),
  endNodeText: z.string().nullish(),
  endNodeXMax: z.number().nullish(),
  endNodeXMin: z.number().nullish(),
  endNodeYMax: z.number().nullish(),
  endNodeYMin: z.number().nullish(),
  name: z.string().nullish(),
  source: z.lazy(() => CogniteSourceSystemSchema.nullish()),
  sourceContext: z.string().nullish(),
  sourceCreatedTime: z.coerce.date().nullish(),
  sourceCreatedUser: z.string().nullish(),
  sourceId: z.string().nullish(),
  sourceUpdatedTime: z.coerce.date().nullish(),
  sourceUpdatedUser: z.string().nullish(),
  startNodePageNumber: z.int64().nullish(),
  startNodeText: z.string().nullish(),
  startNodeXMax: z.number().nullish(),
  startNodeXMin: z.number().nullish(),
  startNodeYMax: z.number().nullish(),
  startNodeYMin: z.number().nullish(),
  status: CogniteAnnotationStatusSchema.nullish(),
  tags: z.array(z.string().nullable()).nullish(),
});

export const CogniteAnnotationSchema: z.ZodObject<Properties<CogniteAnnotation>> = z.object({
  aliases: z.array(z.string().nullable()).nullish(),
  confidence: z.number().nullish(),
  description: z.string().nullish(),
  name: z.string().nullish(),
  source: z.lazy(() => CogniteSourceSystemSchema.nullish()),
  sourceContext: z.string().nullish(),
  sourceCreatedTime: z.coerce.date().nullish(),
  sourceCreatedUser: z.string().nullish(),
  sourceId: z.string().nullish(),
  sourceUpdatedTime: z.coerce.date().nullish(),
  sourceUpdatedUser: z.string().nullish(),
  status: CogniteAnnotationStatusSchema.nullish(),
  tags: z.array(z.string().nullable()).nullish(),
});

export const Cognite360ImageAnnotationSchema: z.ZodObject<Properties<Cognite360ImageAnnotation>> = z.object({
  __typename: z.literal('Cognite360ImageAnnotation').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  confidence: z.number().nullish(),
  description: z.string().nullish(),
  formatVersion: z.string().nullish(),
  name: z.string().nullish(),
  polygon: z.array(z.number().nullable()).nullish(),
  source: z.lazy(() => CogniteSourceSystemSchema.nullish()),
  sourceContext: z.string().nullish(),
  sourceCreatedTime: z.coerce.date().nullish(),
  sourceCreatedUser: z.string().nullish(),
  sourceId: z.string().nullish(),
  sourceUpdatedTime: z.coerce.date().nullish(),
  sourceUpdatedUser: z.string().nullish(),
  status: CogniteAnnotationStatusSchema.nullish(),
  tags: z.array(z.string().nullable()).nullish(),
});

export const Cognite360ImageSchema: z.ZodObject<Properties<Cognite360Image>> = z.object({
  __typename: z.literal('Cognite360Image').optional(),
  back: z.lazy(() => CogniteFileSchema.nullish()),
  bottom: z.lazy(() => CogniteFileSchema.nullish()),
  collection360: z.lazy(() => Cognite360ImageCollectionSchema.nullish()),
  eulerRotationX: z.number().nullish(),
  eulerRotationY: z.number().nullish(),
  eulerRotationZ: z.number().nullish(),
  front: z.lazy(() => CogniteFileSchema.nullish()),
  left: z.lazy(() => CogniteFileSchema.nullish()),
  right: z.lazy(() => CogniteFileSchema.nullish()),
  scaleX: z.number().nullish(),
  scaleY: z.number().nullish(),
  scaleZ: z.number().nullish(),
  station360: z.lazy(() => Cognite360ImageStationSchema.nullish()),
  takenAt: z.coerce.date().nullish(),
  top: z.lazy(() => CogniteFileSchema.nullish()),
  translationX: z.number().nullish(),
  translationY: z.number().nullish(),
  translationZ: z.number().nullish(),
});

export const Cognite3DObjectSchema: z.ZodObject<Properties<Cognite3DObject>> = z.object({
  __typename: z.literal('Cognite3DObject').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  asset: z.lazy(() => CogniteAssetSchema.nullish()),
  cadNodes: z.array(z.lazy(() => CogniteCadNodeSchema.nullable())).nullish(),
  description: z.string().nullish(),
  images360: z.array(z.lazy(() => Cognite360ImageSchema.nullable())).nullish(),
  name: z.string().nullish(),
  pointCloudVolumes: z.array(z.lazy(() => CognitePointCloudVolumeSchema.nullable())).nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  xMax: z.number().nullish(),
  xMin: z.number().nullish(),
  yMax: z.number().nullish(),
  yMin: z.number().nullish(),
  zMax: z.number().nullish(),
  zMin: z.number().nullish(),
});

export const CogniteVisualizableSchema: z.ZodObject<Properties<CogniteVisualizable>> = z.object({
  object3D: z.lazy(() => Cognite3DObjectSchema.nullish()),
});

export const CogniteAssetSchema: z.ZodObject<Properties<CogniteAsset>> = z.object({
  __typename: z.literal('CogniteAsset').optional(),
  activities: z.array(z.lazy(() => CogniteActivitySchema.nullable())).nullish(),
  aliases: z.array(z.string().nullable()).nullish(),
  assetClass: z.lazy(() => CogniteAssetClassSchema.nullish()),
  children: z.array(z.lazy(() => CogniteAssetSchema.nullable())).nullish(),
  description: z.string().nullish(),
  equipment: z.array(z.lazy(() => CogniteEquipmentSchema.nullable())).nullish(),
  files: z.array(z.lazy(() => CogniteFileSchema.nullable())).nullish(),
  name: z.string().nullish(),
  object3D: z.lazy(() => Cognite3DObjectSchema.nullish()),
  parent: z.lazy(() => CogniteAssetSchema.nullish()),
  path: z.array(z.lazy(() => CogniteAssetSchema.nullable())).nullish(),
  pathLastUpdatedTime: z.coerce.date().nullish(),
  root: z.lazy(() => CogniteAssetSchema.nullish()),
  source: z.lazy(() => CogniteSourceSystemSchema.nullish()),
  sourceContext: z.string().nullish(),
  sourceCreatedTime: z.coerce.date().nullish(),
  sourceCreatedUser: z.string().nullish(),
  sourceId: z.string().nullish(),
  sourceUpdatedTime: z.coerce.date().nullish(),
  sourceUpdatedUser: z.string().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  timeSeries: z.array(z.lazy(() => CogniteTimeSeriesSchema.nullable())).nullish(),
  type: z.lazy(() => CogniteAssetTypeSchema.nullish()),
});

export const CogniteActivitySchema: z.ZodObject<Properties<CogniteActivity>> = z.object({
  __typename: z.literal('CogniteActivity').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  assets: z.array(z.lazy(() => CogniteAssetSchema.nullable())).nullish(),
  description: z.string().nullish(),
  endTime: z.coerce.date().nullish(),
  equipment: z.array(z.lazy(() => CogniteEquipmentSchema.nullable())).nullish(),
  name: z.string().nullish(),
  scheduledEndTime: z.coerce.date().nullish(),
  scheduledStartTime: z.coerce.date().nullish(),
  source: z.lazy(() => CogniteSourceSystemSchema.nullish()),
  sourceContext: z.string().nullish(),
  sourceCreatedTime: z.coerce.date().nullish(),
  sourceCreatedUser: z.string().nullish(),
  sourceId: z.string().nullish(),
  sourceUpdatedTime: z.coerce.date().nullish(),
  sourceUpdatedUser: z.string().nullish(),
  startTime: z.coerce.date().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  timeSeries: z.array(z.lazy(() => CogniteTimeSeriesSchema.nullable())).nullish(),
});

export const CogniteEquipmentSchema: z.ZodObject<Properties<CogniteEquipment>> = z.object({
  __typename: z.literal('CogniteEquipment').optional(),
  activities: z.array(z.lazy(() => CogniteActivitySchema.nullable())).nullish(),
  aliases: z.array(z.string().nullable()).nullish(),
  asset: z.lazy(() => CogniteAssetSchema.nullish()),
  description: z.string().nullish(),
  equipmentType: z.lazy(() => CogniteEquipmentTypeSchema.nullish()),
  files: z.array(z.lazy(() => CogniteFileSchema.nullable())).nullish(),
  manufacturer: z.string().nullish(),
  name: z.string().nullish(),
  serialNumber: z.string().nullish(),
  source: z.lazy(() => CogniteSourceSystemSchema.nullish()),
  sourceContext: z.string().nullish(),
  sourceCreatedTime: z.coerce.date().nullish(),
  sourceCreatedUser: z.string().nullish(),
  sourceId: z.string().nullish(),
  sourceUpdatedTime: z.coerce.date().nullish(),
  sourceUpdatedUser: z.string().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  timeSeries: z.array(z.lazy(() => CogniteTimeSeriesSchema.nullable())).nullish(),
});

export const CogniteTimeSeriesSchema: z.ZodObject<Properties<CogniteTimeSeries>> = z.object({
  __typename: z.literal('CogniteTimeSeries').optional(),
  activities: z.array(z.lazy(() => CogniteActivitySchema.nullable())).nullish(),
  aliases: z.array(z.string().nullable()).nullish(),
  assets: z.array(z.lazy(() => CogniteAssetSchema.nullable())).nullish(),
  description: z.string().nullish(),
  equipment: z.array(z.lazy(() => CogniteEquipmentSchema.nullable())).nullish(),
  isStep: z.boolean(),
  name: z.string().nullish(),
  source: z.lazy(() => CogniteSourceSystemSchema.nullish()),
  sourceContext: z.string().nullish(),
  sourceCreatedTime: z.coerce.date().nullish(),
  sourceCreatedUser: z.string().nullish(),
  sourceId: z.string().nullish(),
  sourceUnit: z.string().nullish(),
  sourceUpdatedTime: z.coerce.date().nullish(),
  sourceUpdatedUser: z.string().nullish(),
  stateSet: z.json().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  type: CogniteTimeSeriesTypeSchema.nullish(),
  unit: z.lazy(() => CogniteUnitSchema.nullish()),
});

export const CogniteMaintenanceOrderSchema: z.ZodObject<Properties<CogniteMaintenanceOrder>> = z.object({
  __typename: z.literal('CogniteMaintenanceOrder').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  assets: z.array(z.lazy(() => CogniteAssetSchema.nullable())).nullish(),
  description: z.string().nullish(),
  endTime: z.coerce.date().nullish(),
  equipment: z.array(z.lazy(() => CogniteEquipmentSchema.nullable())).nullish(),
  mainAsset: z.lazy(() => CogniteAssetSchema.nullish()),
  name: z.string().nullish(),
  operations: z.array(z.lazy(() => CogniteOperationSchema.nullable())).nullish(),
  priority: z.int64().nullish(),
  priorityDescription: z.string().nullish(),
  scheduledEndTime: z.coerce.date().nullish(),
  scheduledStartTime: z.coerce.date().nullish(),
  source: z.lazy(() => CogniteSourceSystemSchema.nullish()),
  sourceContext: z.string().nullish(),
  sourceCreatedTime: z.coerce.date().nullish(),
  sourceCreatedUser: z.string().nullish(),
  sourceId: z.string().nullish(),
  sourceUpdatedTime: z.coerce.date().nullish(),
  sourceUpdatedUser: z.string().nullish(),
  startTime: z.coerce.date().nullish(),
  status: z.string().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  timeSeries: z.array(z.lazy(() => CogniteTimeSeriesSchema.nullable())).nullish(),
  type: z.string().nullish(),
});

export const CogniteOperationSchema: z.ZodObject<Properties<CogniteOperation>> = z.object({
  __typename: z.literal('CogniteOperation').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  assets: z.array(z.lazy(() => CogniteAssetSchema.nullable())).nullish(),
  description: z.string().nullish(),
  endTime: z.coerce.date().nullish(),
  equipment: z.array(z.lazy(() => CogniteEquipmentSchema.nullable())).nullish(),
  mainAsset: z.lazy(() => CogniteAssetSchema.nullish()),
  mainDiscipline: z.string().nullish(),
  maintenanceOrder: z.lazy(() => CogniteMaintenanceOrderSchema.nullish()),
  name: z.string().nullish(),
  numberOfMainDiscipline: z.int64().nullish(),
  personHours: z.number().nullish(),
  phase: z.string().nullish(),
  scheduledEndTime: z.coerce.date().nullish(),
  scheduledStartTime: z.coerce.date().nullish(),
  sequence: z.int64().nullish(),
  source: z.lazy(() => CogniteSourceSystemSchema.nullish()),
  sourceContext: z.string().nullish(),
  sourceCreatedTime: z.coerce.date().nullish(),
  sourceCreatedUser: z.string().nullish(),
  sourceId: z.string().nullish(),
  sourceUpdatedTime: z.coerce.date().nullish(),
  sourceUpdatedUser: z.string().nullish(),
  startTime: z.coerce.date().nullish(),
  status: z.string().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  timeSeries: z.array(z.lazy(() => CogniteTimeSeriesSchema.nullable())).nullish(),
});

export const CogniteNotificationSchema: z.ZodObject<Properties<CogniteNotification>> = z.object({
  __typename: z.literal('CogniteNotification').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  asset: z.lazy(() => CogniteAssetSchema.nullish()),
  description: z.string().nullish(),
  endTime: z.coerce.date().nullish(),
  maintenanceOrder: z.lazy(() => CogniteMaintenanceOrderSchema.nullish()),
  name: z.string().nullish(),
  priority: z.int64().nullish(),
  priorityDescription: z.string().nullish(),
  scheduledEndTime: z.coerce.date().nullish(),
  scheduledStartTime: z.coerce.date().nullish(),
  source: z.lazy(() => CogniteSourceSystemSchema.nullish()),
  sourceContext: z.string().nullish(),
  sourceCreatedTime: z.coerce.date().nullish(),
  sourceCreatedUser: z.string().nullish(),
  sourceId: z.string().nullish(),
  sourceUpdatedTime: z.coerce.date().nullish(),
  sourceUpdatedUser: z.string().nullish(),
  startTime: z.coerce.date().nullish(),
  status: z.string().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  type: z.string().nullish(),
});

export const CogniteFileSchema: z.ZodObject<Properties<CogniteFile>> = z.object({
  __typename: z.literal('CogniteFile').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  assets: z.array(z.lazy(() => CogniteAssetSchema.nullable())).nullish(),
  category: z.lazy(() => CogniteFileCategorySchema.nullish()),
  description: z.string().nullish(),
  directory: z.string().nullish(),
  equipment: z.array(z.lazy(() => CogniteEquipmentSchema.nullable())).nullish(),
  isUploaded: z.boolean().nullish(),
  mimeType: z.string().nullish(),
  name: z.string().nullish(),
  source: z.lazy(() => CogniteSourceSystemSchema.nullish()),
  sourceContext: z.string().nullish(),
  sourceCreatedTime: z.coerce.date().nullish(),
  sourceCreatedUser: z.string().nullish(),
  sourceId: z.string().nullish(),
  sourceUpdatedTime: z.coerce.date().nullish(),
  sourceUpdatedUser: z.string().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  uploadedTime: z.coerce.date().nullish(),
});

export const CognitePointCloudModelSchema: z.ZodObject<Properties<CognitePointCloudModel>> = z.object({
  __typename: z.literal('CognitePointCloudModel').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  description: z.string().nullish(),
  name: z.string().nullish(),
  revisions: z.array(z.lazy(() => CognitePointCloudRevisionSchema.nullable())).nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  thumbnail: z.lazy(() => CogniteFileSchema.nullish()),
  type: Cognite3DModelTypeSchema.nullish(),
});

export const CognitePointCloudRevisionSchema: z.ZodObject<Properties<CognitePointCloudRevision>> = z.object({
  __typename: z.literal('CognitePointCloudRevision').optional(),
  model3D: z.lazy(() => CognitePointCloudModelSchema.nullish()),
  published: z.boolean().nullish(),
  revisionId: z.int64().nullish(),
  status: Cognite3DRevisionStatusSchema.nullish(),
  type: Cognite3DRevisionTypeSchema.nullish(),
});

export const CogniteCubeMapSchema: z.ZodObject<Properties<CogniteCubeMap>> = z.object({
  back: z.lazy(() => CogniteFileSchema.nullish()),
  bottom: z.lazy(() => CogniteFileSchema.nullish()),
  front: z.lazy(() => CogniteFileSchema.nullish()),
  left: z.lazy(() => CogniteFileSchema.nullish()),
  right: z.lazy(() => CogniteFileSchema.nullish()),
  top: z.lazy(() => CogniteFileSchema.nullish()),
});

export const CogniteCadModelSchema: z.ZodObject<Properties<CogniteCadModel>> = z.object({
  __typename: z.literal('CogniteCADModel').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  description: z.string().nullish(),
  name: z.string().nullish(),
  revisions: z.array(z.lazy(() => CogniteCadRevisionSchema.nullable())).nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  thumbnail: z.lazy(() => CogniteFileSchema.nullish()),
  type: Cognite3DModelTypeSchema.nullish(),
});

export const CogniteCadRevisionSchema: z.ZodObject<Properties<CogniteCadRevision>> = z.object({
  __typename: z.literal('CogniteCADRevision').optional(),
  model3D: z.lazy(() => CogniteCadModelSchema.nullish()),
  published: z.boolean().nullish(),
  revisionId: z.int64().nullish(),
  status: Cognite3DRevisionStatusSchema.nullish(),
  type: Cognite3DRevisionTypeSchema.nullish(),
});

export const CognitePointCloudVolumeSchema: z.ZodObject<Properties<CognitePointCloudVolume>> = z.object({
  __typename: z.literal('CognitePointCloudVolume').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  description: z.string().nullish(),
  formatVersion: z.string().nullish(),
  model3D: z.lazy(() => CogniteCadModelSchema.nullish()),
  name: z.string().nullish(),
  object3D: z.lazy(() => Cognite3DObjectSchema.nullish()),
  revisions: z.array(z.lazy(() => CogniteCadRevisionSchema.nullable())).nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  volume: z.array(z.number().nullable()).nullish(),
  volumeReferences: z.array(z.string().nullable()).nullish(),
  volumeType: CognitePointCloudVolumeVolumeTypeSchema.nullish(),
});

export const CogniteCadNodeSchema: z.ZodObject<Properties<CogniteCadNode>> = z.object({
  __typename: z.literal('CogniteCADNode').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  cadNodeReference: z.string().nullish(),
  description: z.string().nullish(),
  model3D: z.lazy(() => CogniteCadModelSchema.nullish()),
  name: z.string().nullish(),
  object3D: z.lazy(() => Cognite3DObjectSchema.nullish()),
  revisions: z.array(z.lazy(() => CogniteCadRevisionSchema.nullable())).nullish(),
  subTreeSizes: z.array(z.int64().nullable()).nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  treeIndexes: z.array(z.int64().nullable()).nullish(),
});

export const Cognite360ImageModelSchema: z.ZodObject<Properties<Cognite360ImageModel>> = z.object({
  __typename: z.literal('Cognite360ImageModel').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  collections: z.array(z.lazy(() => Cognite360ImageCollectionSchema.nullable())).nullish(),
  description: z.string().nullish(),
  name: z.string().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  thumbnail: z.lazy(() => CogniteFileSchema.nullish()),
  type: Cognite3DModelTypeSchema.nullish(),
});

export const Cognite360ImageCollectionSchema: z.ZodObject<Properties<Cognite360ImageCollection>> = z.object({
  __typename: z.literal('Cognite360ImageCollection').optional(),
  aliases: z.array(z.string().nullable()).nullish(),
  description: z.string().nullish(),
  model3D: z.lazy(() => Cognite360ImageModelSchema.nullish()),
  name: z.string().nullish(),
  published: z.boolean().nullish(),
  status: Cognite3DRevisionStatusSchema.nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  type: Cognite3DRevisionTypeSchema.nullish(),
});

export const Cognite3DModelSchema: z.ZodObject<Properties<Cognite3DModel>> = z.object({
  aliases: z.array(z.string().nullable()).nullish(),
  description: z.string().nullish(),
  name: z.string().nullish(),
  tags: z.array(z.string().nullable()).nullish(),
  thumbnail: z.lazy(() => CogniteFileSchema.nullish()),
  type: Cognite3DModelTypeSchema.nullish(),
});

export const Cognite3DRevisionSchema: z.ZodObject<Properties<Cognite3DRevision>> = z.object({
  model3D: z.lazy(() => Cognite3DModelSchema.nullish()),
  published: z.boolean().nullish(),
  status: Cognite3DRevisionStatusSchema.nullish(),
  type: Cognite3DRevisionTypeSchema.nullish(),
});

export const AssetSchema: z.ZodObject<Properties<Asset>> = z.object({
  __typename: z.literal('Asset').optional(),
  endDateTime: z.coerce.date().nullish(),
  entityType: z.string().nullish(),
  name: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
});

export const WellInputsStaticSchema: z.ZodObject<Properties<WellInputsStatic>> = z.object({
  __typename: z.literal('WellInputs_Static').optional(),
  crs: z.float32().nullish(),
  elevation: z.float32().nullish(),
  elevationRef: z.string().nullish(),
  entityName: z.lazy(() => WellSchema.nullish()),
  latitude: z.float32().nullish(),
  longitude: z.float32().nullish(),
  originalCRS: z.float32().nullish(),
  originalX: z.float32().nullish(),
  originalY: z.float32().nullish(),
  spudDate: z.coerce.date().nullish(),
});

export const SPressSettingsSchema: z.ZodObject<Properties<SPressSettings>> = z.object({
  __typename: z.literal('SPressSettings').optional(),
  dateTime: z.coerce.date().nullish(),
  entityName: z.lazy(() => EntitySchema.nullish()),
  maxReservoirPressure: z.float32().nullish(),
  minNumberShutInPressures: z.number().nullish(),
  minReservoirPressure: z.float32().nullish(),
});

export const PseudoPressureTableSchema: z.ZodObject<Properties<PseudoPressureTable>> = z.object({
  __typename: z.literal('PseudoPressureTable').optional(),
  pressure: z.float32().nullish(),
  pseudoPressure: z.float32().nullish(),
});

export const MapGridMappingSchema: z.ZodObject<Properties<MapGridMapping>> = z.object({
  __typename: z.literal('MapGrid_Mapping').optional(),
  date: z.coerce.date().nullish(),
  fieldName: z.string().nullish(),
  lat: z.float32().nullish(),
  long: z.float32().nullish(),
  p10: z.float32().nullish(),
  p50: z.float32().nullish(),
  p90: z.float32().nullish(),
  reservoirName: z.string().nullish(),
  reservoirPressureMapGrid: z.float32().nullish(),
  reservoirPressureRMSError: z.float32().nullish(),
  x: z.float32().nullish(),
  y: z.float32().nullish(),
});

export const DataMappingSchema: z.ZodObject<Properties<DataMapping>> = z.object({
  __typename: z.literal('Data_Mapping').optional(),
  date: z.coerce.date().nullish(),
  fieldName: z.string().nullish(),
  lat: z.float32().nullish(),
  long: z.float32().nullish(),
  reservoirName: z.string().nullish(),
  reservoirPressureRMSError: z.float32().nullish(),
  reservoirPressureString: z.float32().nullish(),
  stringName: z.string().nullish(),
  x: z.float32().nullish(),
  y: z.float32().nullish(),
});

export const ChokeCurveInfoSchema: z.ZodObject<Properties<ChokeCurveInfo>> = z.object({
  __typename: z.literal('Choke_Curve_Info').optional(),
  chokeBeanSize: z.float32().nullish(),
  chokeOpening: z.float32().nullish(),
  chokeType: z.string().nullish(),
});

export const AsphalteneCurveSchema: z.ZodObject<Properties<AsphalteneCurve>> = z.object({
  __typename: z.literal('Asphaltene_Curve').optional(),
  asphP: z.float32().nullish(),
  asphT: z.float32().nullish(),
  asphTable: z.string().nullish(),
  date: z.coerce.date().nullish(),
  sequence: z.number().nullish(),
});

export const FieldSchema: z.ZodObject<Properties<Field>> = z.object({
  __typename: z.literal('Field').optional(),
  endDateTime: z.coerce.date().nullish(),
  entityType: z.string().nullish(),
  name: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
});

export const WfFieldAlarmsSchema: z.ZodObject<Properties<WfFieldAlarms>> = z.object({
  __typename: z.literal('WfFieldAlarms').optional(),
  alarmCounter: z.number().nullish(),
  alarmFlags: z.string().nullish(),
  alarmLevel: z.string().nullish(),
  alarmMessage: z.string().nullish(),
  alarmName: z.string().nullish(),
  alarmType: z.string().nullish(),
  configuration: z.string().nullish(),
  endDateTime: z.coerce.date().nullish(),
  entityName: z.lazy(() => FieldSchema.nullish()),
  operationType: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
  ticketId: z.string().nullish(),
  workflowName: z.string().nullish(),
});

export const SectorProdplanSchema: z.ZodObject<Properties<SectorProdplan>> = z.object({
  __typename: z.literal('Sector_Prodplan').optional(),
  effectiveDate: z.coerce.date().nullish(),
  field: z.lazy(() => FieldSchema.nullish()),
  reservoir: z.lazy(() => ReservoirSchema.nullish()),
  sector: z.lazy(() => SectorSchema.nullish()),
  submittedMonth: z.coerce.date().nullish(),
  vrrTarget: z.float32().nullish(),
});

export const SrmSettingsSchema: z.ZodObject<Properties<SrmSettings>> = z.object({
  __typename: z.literal('SRMSettings').optional(),
  allocationFactorType: z.string().nullish(),
  chokeCalculation: z.string().nullish(),
  entityName: z.lazy(() => FieldSchema.nullish()),
  gasInjectionWeight: z.float32().nullish(),
  gasProductionWeight: z.float32().nullish(),
  maxIterations: z.number().nullish(),
  minNumberWellTests: z.number().nullish(),
  minRatio: z.float32().nullish(),
  rateConstraintOption: z.string().nullish(),
  vrrWeight: z.float32().nullish(),
  waterInjectionWeight: z.float32().nullish(),
  waterProductionWeight: z.float32().nullish(),
});

export const ReservoirProdplanSchema: z.ZodObject<Properties<ReservoirProdplan>> = z.object({
  __typename: z.literal('Reservoir_Prodplan').optional(),
  effectiveDate: z.coerce.date().nullish(),
  field: z.lazy(() => FieldSchema.nullish()),
  prodTarget: z.float32().nullish(),
  reservoir: z.lazy(() => ReservoirSchema.nullish()),
  submittedMonth: z.coerce.date().nullish(),
  vrrTarget: z.float32().nullish(),
});

export const ReservoirGuidelineSchema: z.ZodObject<Properties<ReservoirGuideline>> = z.object({
  __typename: z.literal('Reservoir_Guideline').optional(),
  effectiveDate: z.coerce.date().nullish(),
  expectedReservoirPressure: z.float32().nullish(),
  field: z.lazy(() => FieldSchema.nullish()),
  reservoir: z.lazy(() => ReservoirSchema.nullish()),
  reservoirAllowableRate: z.float32().nullish(),
  sector: z.lazy(() => SectorSchema.nullish()),
  technicalGasRate: z.float32().nullish(),
  technicalOilRate: z.float32().nullish(),
  vrrRequirement: z.float32().nullish(),
  vrrTarget: z.float32().nullish(),
});

export const PtsReferenceConditionsSchema: z.ZodObject<Properties<PtsReferenceConditions>> = z.object({
  __typename: z.literal('PTS_Reference_Conditions').optional(),
  date: z.coerce.date().nullish(),
  fieldCode: z.string().nullish(),
  fieldName: z.lazy(() => FieldSchema.nullish()),
  refStgPress1: z.float32().nullish(),
  refStgPress2: z.float32().nullish(),
  refStgPress3: z.float32().nullish(),
  refStgPress4: z.float32().nullish(),
  refStgPress5: z.float32().nullish(),
  refStgTemp1: z.float32().nullish(),
  refStgTemp2: z.float32().nullish(),
  refStgTemp3: z.float32().nullish(),
  refStgTemp4: z.float32().nullish(),
  refStgTemp5: z.float32().nullish(),
});

export const NetworkSchema: z.ZodObject<Properties<Network>> = z.object({
  __typename: z.literal('Network').optional(),
  connectedFields: z.array(z.lazy(() => FieldSchema.nullable())).nullish(),
  endDateTime: z.coerce.date().nullish(),
  entityType: z.string().nullish(),
  field: z.array(z.lazy(() => FieldSchema.nullable())).nullish(),
  fieldName: z.lazy(() => FieldSchema.nullish()),
  linkedField: z.array(z.json().nullable()).nullish(),
  name: z.string().nullish(),
  networkType: z.string().nullish(),
  primaryFluid: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
});

export const NetworkModelSchema: z.ZodObject<Properties<NetworkModel>> = z.object({
  __typename: z.literal('NetworkModel').optional(),
  changeDetails: z.string().nullish(),
  connectedFields: z.array(z.lazy(() => FieldSchema.nullable())).nullish(),
  description: z.string().nullish(),
  garFileName: z.string().nullish(),
  legacyGapFileExternalId: z.string().nullish(),
  legacyGapFileId: z.int64().nullish(),
  legacyGarFileExternalId: z.string().nullish(),
  legacyGarFileId: z.int64().nullish(),
  legacyInputGapFileId: z.int64().nullish(),
  legacyInputGarFileId: z.int64().nullish(),
  modelConfig: z.json().nullish(),
  modelConfigLegacyFileExternalId: z.string().nullish(),
  modelEffectiveTime: z.coerce.date().nullish(),
  modelSimIntRevisionConfigLegacyFileExternalId: z.string().nullish(),
  modelUpdatedBy: z.string().nullish(),
  modelUpdatedTime: z.coerce.date().nullish(),
  modelUploadedBy: z.string().nullish(),
  modelUploadedTime: z.coerce.date().nullish(),
  network: z.lazy(() => NetworkSchema.nullish()),
  networkType: z.string().nullish(),
  originalGarFileName: z.string().nullish(),
  pressureMatchedWellModels: z.number().nullish(),
  productivityIndexDifferencePercentage: z.json().nullish(),
  simIntExternalId: z.string().nullish(),
  simIntModelExternalId: z.string().nullish(),
  simIntModelRevisionCreatedTime: z.coerce.date().nullish(),
  simIntModelRevisionDescription: z.string().nullish(),
  simIntModelRevisionExternalId: z.string().nullish(),
  simIntModelRevisionId: z.string().nullish(),
  simIntModelRevisionLogId: z.string().nullish(),
  simIntModelRevisionStatus: z.string().nullish(),
  simIntModelRevisionStatusMessage: z.string().nullish(),
  simIntModelRevisionUpdatedTime: z.coerce.date().nullish(),
  simIntModelRevisionVersionId: z.number().nullish(),
  source: z.string().nullish(),
  status: z.string().nullish(),
  totalWellModels: z.number().nullish(),
  wf8Processed: z.boolean().nullish(),
  wf9Consumed: z.boolean().nullish(),
  wf9Processed: z.boolean().nullish(),
});

export const FieldFormationSchema: z.ZodObject<Properties<FieldFormation>> = z.object({
  __typename: z.literal('FieldFormation').optional(),
  datumDepth: z.float32().nullish(),
  field: z.lazy(() => FieldSchema.nullish()),
  gasGradient: z.float32().nullish(),
  gasOilContact: z.float32().nullish(),
  gaswaterContact: z.float32().nullish(),
  oilGradient: z.float32().nullish(),
  oilWaterContact: z.float32().nullish(),
  reservoir: z.lazy(() => ReservoirSchema.nullish()),
  reservoirType: z.string().nullish(),
  rw: z.float32().nullish(),
  startDateTime: z.coerce.date().nullish(),
  stopDateTime: z.coerce.date().nullish(),
  waterGradient: z.float32().nullish(),
});

export const StringAssetSchema: z.ZodObject<Properties<StringAsset>> = z.object({
  __typename: z.literal('String_asset').optional(),
  endDateTime: z.coerce.date().nullish(),
  entityType: z.string().nullish(),
  name: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
});

export const WfStringAlarmsSchema: z.ZodObject<Properties<WfStringAlarms>> = z.object({
  __typename: z.literal('WfStringAlarms').optional(),
  alarmCounter: z.number().nullish(),
  alarmFlags: z.string().nullish(),
  alarmLevel: z.string().nullish(),
  alarmMessage: z.string().nullish(),
  alarmName: z.string().nullish(),
  alarmType: z.string().nullish(),
  configuration: z.string().nullish(),
  endDateTime: z.coerce.date().nullish(),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  operationType: z.string().nullish(),
  startDateTime: z.coerce.date().nullish(),
  ticketId: z.string().nullish(),
  workflowName: z.string().nullish(),
});

export const WfAlarmsAgentSchema: z.ZodObject<Properties<WfAlarmsAgent>> = z.object({
  __typename: z.literal('WfAlarms_Agent').optional(),
  alarmCategory: z.string().nullish(),
  alarmCode: z.json().nullish(),
  alarmCodeExternalId: z.string().nullish(),
  alarmCounter: z.number().nullish(),
  alarmCriticality: z.string().nullish(),
  alarmFlags: z.string().nullish(),
  alarmMessage: z.string().nullish(),
  alarmName: z.string().nullish(),
  alarmPriority: z.string().nullish(),
  customWorkflowAlarmMessage: z.string().nullish(),
  endDateTime: z.coerce.date().nullish(),
  entityExternalId: z.string(),
  entityName: z.string(),
  entityType: z.string(),
  startDateTime: z.coerce.date(),
  subCategory: z.string().nullish(),
  subWorkflowName: z.string().nullish(),
  ticketId: z.string().nullish(),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  workflowCode: z.string().nullish(),
  workflowName: z.string().nullish(),
});

export const WellMovementAgentSchema: z.ZodObject<Properties<WellMovementAgent>> = z.object({
  __typename: z.literal('WellMovement_Agent').optional(),
  actualExecutionDate: z.iso.date().nullish(),
  baselineGasRate: z.number().nullish(),
  baselineOilRate: z.number().nullish(),
  baselineWaterRate: z.number().nullish(),
  controlParameter: z.string().nullish(),
  controlParameterPostOptimizedValue: z.number().nullish(),
  controlParameterPreOptimizedValue: z.number().nullish(),
  createdBy: z.string().nullish(),
  createdDate: z.iso.date().nullish(),
  description: z.string().nullish(),
  doNotDisturb: z.boolean().nullish(),
  doNotDisturbEndDate: z.iso.date().nullish(),
  estimatedGasRate: z.number().nullish(),
  estimatedOilRate: z.number().nullish(),
  estimatedWaterRate: z.number().nullish(),
  executionStatus: z.string().nullish(),
  plannedExecutionDate: z.iso.date().nullish(),
  scenarioName: z.string().nullish(),
  scenarioType: z.string().nullish(),
  source: z.string().nullish(),
  status: z.string().nullish(),
  ticketExternalId: z.string().nullish(),
  validationStatus: z.string().nullish(),
  wellName: z.string().nullish(),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  wellType: z.string().nullish(),
});

export const WellBehaviourAlarmsAgentSchema: z.ZodObject<Properties<WellBehaviourAlarmsAgent>> = z.object({
  __typename: z.literal('WellBehaviourAlarms_Agent').optional(),
  alarmCategory: z.string().nullish(),
  alarmCode: z.json().nullish(),
  alarmCodeExternalId: z.string().nullish(),
  alarmCriticality: z.string().nullish(),
  alarmFlags: z.string().nullish(),
  alarmName: z.string().nullish(),
  alarmPriority: z.string().nullish(),
  customWorkflowAlarmMessage: z.string().nullish(),
  endDateTime: z.coerce.date().nullish(),
  entityExternalId: z.string(),
  entityName: z.string(),
  entityType: z.string(),
  startDateTime: z.coerce.date(),
  subCategory: z.string().nullish(),
  subWorkflowName: z.string().nullish(),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  workflowCode: z.string().nullish(),
  workflowName: z.string().nullish(),
});

export const SurveillanceAlarmsAgentSchema: z.ZodObject<Properties<SurveillanceAlarmsAgent>> = z.object({
  __typename: z.literal('SurveillanceAlarms_Agent').optional(),
  alarmCategory: z.string().nullish(),
  alarmCode: z.json().nullish(),
  alarmCodeExternalId: z.string().nullish(),
  alarmCriticality: z.string().nullish(),
  alarmFlags: z.string().nullish(),
  alarmName: z.string().nullish(),
  alarmPriority: z.string().nullish(),
  customWorkflowAlarmMessage: z.string().nullish(),
  endDateTime: z.coerce.date().nullish(),
  entityExternalId: z.string(),
  entityName: z.string(),
  entityType: z.string(),
  startDateTime: z.coerce.date(),
  subCategory: z.string().nullish(),
  subWorkflowName: z.string().nullish(),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  workflowCode: z.string().nullish(),
  workflowName: z.string().nullish(),
});

export const StringInputsStaticSchema: z.ZodObject<Properties<StringInputsStatic>> = z.object({
  __typename: z.literal('StringInputs_Static').optional(),
  baseLatMidPerf: z.float32().nullish(),
  baseLongMidPerf: z.float32().nullish(),
  baseX: z.float32().nullish(),
  baseXMidPerf: z.float32().nullish(),
  baseY: z.float32().nullish(),
  baseYMidPerf: z.float32().nullish(),
  boreholeShape: z.string().nullish(),
  bottomDepth: z.float32().nullish(),
  crs: z.string().nullish(),
  elevation: z.float32().nullish(),
  elevationRef: z.string().nullish(),
  endDate: z.coerce.date().nullish(),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  originalBaseX: z.float32().nullish(),
  originalBaseY: z.float32().nullish(),
  originalTopX: z.float32().nullish(),
  originalTopY: z.float32().nullish(),
  startDate: z.coerce.date().nullish(),
  topDepth: z.float32().nullish(),
  topX: z.float32().nullish(),
  topY: z.float32().nullish(),
  wellbore: z.string().nullish(),
  wellboreType: z.string().nullish(),
});

export const SectorHierarchyAgentSchema: z.ZodObject<Properties<SectorHierarchyAgent>> = z.object({
  __typename: z.literal('SectorHierarchy_Agent').optional(),
  allocationFactor: z.float32().nullish(),
  endDateTime: z.coerce.date().nullish(),
  reservoir: z.lazy(() => ReservoirSchema.nullish()),
  sector: z.lazy(() => SectorSchema.nullish()),
  startDateTime: z.coerce.date().nullish(),
  string: z.lazy(() => StringAssetSchema.nullish()),
  well: z.lazy(() => WellSchema.nullish()),
});

export const SectorHierarchySchema: z.ZodObject<Properties<SectorHierarchy>> = z.object({
  __typename: z.literal('SectorHierarchy').optional(),
  allocationFactor: z.float32().nullish(),
  endDateTime: z.coerce.date().nullish(),
  reservoir: z.lazy(() => ReservoirSchema.nullish()),
  sector: z.lazy(() => SectorSchema.nullish()),
  startDateTime: z.coerce.date().nullish(),
  string: z.lazy(() => StringAssetSchema.nullish()),
  well: z.lazy(() => WellSchema.nullish()),
});

export const SaturationPressureMappingSchema: z.ZodObject<Properties<SaturationPressureMapping>> = z.object({
  __typename: z.literal('Saturation_Pressure_Mapping').optional(),
  asphTable: z.string().nullish(),
  effectiveDate: z.coerce.date().nullish(),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  prpFile: z.string().nullish(),
  pvtFile: z.string().nullish(),
  pvtRef: z.string().nullish(),
  resTemp: z.float32().nullish(),
  satPress: z.float32().nullish(),
  solutionGOR: z.float32().nullish(),
  wat: z.float32().nullish(),
});

export const ShgProducerGuidelineSchema: z.ZodObject<Properties<ShgProducerGuideline>> = z.object({
  __typename: z.literal('SHG_Producer_Guideline').optional(),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  maxGOR: z.float32().nullish(),
  maxLiquidRate: z.float32().nullish(),
  maxOilRate: z.float32().nullish(),
  minBHP: z.float32().nullish(),
  minWHP: z.float32().nullish(),
});

export const ProsperModelAgentSchema: z.ZodObject<Properties<ProsperModelAgent>> = z.object({
  __typename: z.literal('ProsperModel_Agent').optional(),
  espCurrentCable: z.string().nullish(),
  espCurrentMotor: z.string().nullish(),
  espPumpModel: z.string().nullish(),
  field: z.lazy(() => FieldSchema.nullish()),
  iprModel: z.string().nullish(),
  liftMethod: z.number().nullish(),
  minStableRate: z.number().nullish(),
  modelEffectiveTime: z.coerce.date().nullish(),
  modelStatus: z.string().nullish(),
  modelUpdatedTime: z.coerce.date().nullish(),
  modelUploadedTime: z.coerce.date().nullish(),
  pi: z.number().nullish(),
  reservoirPressure: z.number().nullish(),
  string_name: z.string().nullish(),
  vlpModel: z.string().nullish(),
  wearFactor: z.number().nullish(),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  wf2ModelMatchedStatus: z.string().nullish(),
  wf3ModelMatchedStatus: z.string().nullish(),
});

export const ProsperModelSchema: z.ZodObject<Properties<ProsperModel>> = z.object({
  __typename: z.literal('ProsperModel').optional(),
  asphalteneCurve: z.json().nullish(),
  bottomPerforationDepth: z.number().nullish(),
  bottomPerforationDepthUnit: z.string().nullish(),
  bottomTubingId: z.number().nullish(),
  bottomTubingIdUnit: z.string().nullish(),
  bubblePoint: z.json().nullish(),
  cCoefficient: z.number().nullish(),
  cCoefficientUnit: z.string().nullish(),
  calibrationWellTestRate: z.number().nullish(),
  calibrationWellTestRateUnit: z.string().nullish(),
  calibrationWellTestTime: z.coerce.date().nullish(),
  changeDetails: z.string().nullish(),
  criticalPoint: z.json().nullish(),
  description: z.string().nullish(),
  deviationSurveyRecordCount: z.number().nullish(),
  espCurrentCable: z.string().nullish(),
  espCurrentMotor: z.string().nullish(),
  espPumpDepth: z.number().nullish(),
  espPumpDepthUnit: z.string().nullish(),
  espPumpModel: z.string().nullish(),
  espStages: z.number().nullish(),
  executeStatus: z.string().nullish(),
  fbhpAtMinStableRate: z.number().nullish(),
  fbhpAtMinStableRateUnit: z.string().nullish(),
  field: z.lazy(() => FieldSchema.nullish()),
  fileSize: z.number().nullish(),
  flowExponent: z.number().nullish(),
  fluid: z.number().nullish(),
  geoThermalGradientRecordCount: z.number().nullish(),
  glInjectionDepth: z.number().nullish(),
  glInjectionDepthUnit: z.string().nullish(),
  glMethod: z.number().nullish(),
  glOrificeSize: z.number().nullish(),
  glOrificeSizeUnit: z.string().nullish(),
  glValveDepth: z.number().nullish(),
  glValveDepthUnit: z.string().nullish(),
  hydrateCurve: z.json().nullish(),
  iprModel: z.string().nullish(),
  legacyDataSetId: z.int64().nullish(),
  legacyFileExternalId: z.string().nullish(),
  legacyFileId: z.int64().nullish(),
  liftMethod: z.number().nullish(),
  maxMeasuredDepth: z.number().nullish(),
  maxMeasuredDepthUnit: z.string().nullish(),
  maxTrueVerticalDepth: z.number().nullish(),
  maxTrueVerticalDepthUnit: z.string().nullish(),
  mimeType: z.string().nullish(),
  minStableRate: z.number().nullish(),
  minStableRateUnit: z.string().nullish(),
  modelAcceptedBy: z.string().nullish(),
  modelAcceptedTime: z.coerce.date().nullish(),
  modelEffectiveTime: z.coerce.date().nullish(),
  modelStatus: z.string().nullish(),
  modelUpdatedBy: z.string().nullish(),
  modelUpdatedTime: z.coerce.date().nullish(),
  modelUploadedBy: z.string().nullish(),
  modelUploadedTime: z.coerce.date().nullish(),
  name: z.string().nullish(),
  originalProsperFileName: z.string().nullish(),
  pE5Flag: z.number().nullish(),
  pendingModifications: z.json().nullish(),
  phaseEnvelope: z.json().nullish(),
  pi: z.number().nullish(),
  piUnit: z.string().nullish(),
  platform: z.string().nullish(),
  prosperLocationName: z.string().nullish(),
  prosperWellName: z.string().nullish(),
  pvt: z.number().nullish(),
  pvtUnit: z.string().nullish(),
  rateDeviationPercentage: z.number().nullish(),
  reservoir: z.array(z.lazy(() => ReservoirSchema.nullable())).nullish(),
  reservoirBubblePoint: z.number().nullish(),
  reservoirBubblePointUnit: z.string().nullish(),
  reservoirPressure: z.number().nullish(),
  reservoirPressureUnit: z.string().nullish(),
  reservoirTemperature: z.number().nullish(),
  reservoirTemperatureUnit: z.string().nullish(),
  simIntExternalId: z.string().nullish(),
  simIntModelExternalId: z.string().nullish(),
  simIntModelRevisionCreatedTime: z.coerce.date().nullish(),
  simIntModelRevisionDescription: z.string().nullish(),
  simIntModelRevisionExternalId: z.string().nullish(),
  simIntModelRevisionId: z.string().nullish(),
  simIntModelRevisionLogId: z.string().nullish(),
  simIntModelRevisionStatus: z.string().nullish(),
  simIntModelRevisionStatusMessage: z.string().nullish(),
  simIntModelRevisionUpdatedTime: z.coerce.date().nullish(),
  simIntModelRevisionVersionId: z.number().nullish(),
  source: z.string().nullish(),
  sourceLocation: z.string().nullish(),
  string: z.lazy(() => StringAssetSchema.nullish()),
  string_name: z.string().nullish(),
  topPerforationDepth: z.number().nullish(),
  topPerforationDepthUnit: z.string().nullish(),
  uVal: z.number().nullish(),
  uValUnit: z.string().nullish(),
  vlpModel: z.string().nullish(),
  waxCurve: z.json().nullish(),
  wearFactor: z.number().nullish(),
  well: z.lazy(() => WellSchema.nullish()),
  wellCompletionRecordCount: z.number().nullish(),
  wellType: z.number().nullish(),
  wf2EstimatedRate: z.number().nullish(),
  wf2ModelMatchedStatus: z.string().nullish(),
  wf2Processed: z.string().nullish(),
  wf3EstimatedRate: z.number().nullish(),
  wf3EstimatedRateUnit: z.string().nullish(),
  wf3ModelMatchedStatus: z.string().nullish(),
});

export const ProsperModelEventLogSchema: z.ZodObject<Properties<ProsperModelEventLog>> = z.object({
  __typename: z.literal('ProsperModelEventLog').optional(),
  modelAcceptedBy: z.string().nullish(),
  modelAcceptedTime: z.coerce.date().nullish(),
  modelStatus: z.string().nullish(),
  modelUpdatedBy: z.string().nullish(),
  modelUpdatedTime: z.coerce.date().nullish(),
  prosperModel: z.lazy(() => ProsperModelSchema.nullish()),
  wf3ModelMatchedStatus: z.string().nullish(),
});

export const ProductionAllocationAlarmsAgentSchema: z.ZodObject<Properties<ProductionAllocationAlarmsAgent>> = z.object(
  {
    __typename: z.literal('ProductionAllocationAlarms_Agent').optional(),
    alarmCategory: z.string().nullish(),
    alarmCode: z.json().nullish(),
    alarmCodeExternalId: z.string().nullish(),
    alarmCounter: z.number().nullish(),
    alarmCriticality: z.string().nullish(),
    alarmFlags: z.string().nullish(),
    alarmName: z.string().nullish(),
    alarmPriority: z.string().nullish(),
    customWorkflowAlarmMessage: z.string().nullish(),
    endDateTime: z.coerce.date().nullish(),
    entityExternalId: z.string(),
    entityName: z.string(),
    entityType: z.string(),
    startDateTime: z.coerce.date(),
    subCategory: z.string().nullish(),
    subWorkflowName: z.string().nullish(),
    ticketId: z.string().nullish(),
    wellString: z.lazy(() => StringAssetSchema.nullish()),
    workflowCode: z.string().nullish(),
    workflowName: z.string().nullish(),
  },
);

export const ProducerGuidelinesStringAgentSchema: z.ZodObject<Properties<ProducerGuidelinesStringAgent>> = z.object({
  __typename: z.literal('ProducerGuidelines_String_Agent').optional(),
  maxGOR: z.float32().nullish(),
  maxLiquidRate: z.float32().nullish(),
  maxOilRate: z.float32().nullish(),
  minBHP: z.float32().nullish(),
  minWHP: z.float32().nullish(),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const OpportunityAgentSchema: z.ZodObject<Properties<OpportunityAgent>> = z.object({
  __typename: z.literal('Opportunity_Agent').optional(),
  actualExecutionDate: z.iso.date().nullish(),
  baselineGasRate: z.number().nullish(),
  baselineOilRate: z.number().nullish(),
  baselineWaterRate: z.number().nullish(),
  createdDate: z.iso.date().nullish(),
  cumulativeOilGain: z.number().nullish(),
  description: z.string().nullish(),
  estimatedGasRate: z.number().nullish(),
  estimatedOilRate: z.number().nullish(),
  estimatedWaterRate: z.number().nullish(),
  interventionActivity: z.string().nullish(),
  owner: z.string().nullish(),
  plannedExecutionDate: z.iso.date().nullish(),
  source: z.string().nullish(),
  status: z.string().nullish(),
  summary: z.string().nullish(),
  ticketExternalID: z.string().nullish(),
  type: z.string().nullish(),
  validationComments: z.string().nullish(),
  validationStatus: z.string().nullish(),
  valueTrackingEndDate: z.iso.date().nullish(),
  valueTrackingEndReason: z.string().nullish(),
  valueTrackingStatus: z.string().nullish(),
  wellName: z.string().nullish(),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  wellType: z.string().nullish(),
});

export const MpfmWellTestOutputsSchema: z.ZodObject<Properties<MpfmWellTestOutputs>> = z.object({
  __typename: z.literal('MpfmWellTestOutputs').optional(),
  alarmCount: z.number().nullish(),
  entityName: z.lazy(() => MpfmSchema.nullish()),
  field: z.lazy(() => FieldSchema.nullish()),
  process1Flag: z.string().nullish(),
  process2Flag: z.string().nullish(),
  process3Flag: z.string().nullish(),
  process4Flag: z.string().nullish(),
  singlePointWellTestFlag: z.string().nullish(),
  stablePeriodEndDateTime: z.coerce.date().nullish(),
  stablePeriodFlag: z.string().nullish(),
  stablePeriodStartDateTime: z.coerce.date().nullish(),
  startDateTime: z.coerce.date().nullish(),
  stringOnTest: z.lazy(() => StringAssetSchema.nullish()),
  wellOnTest: z.lazy(() => WellSchema.nullish()),
  wellTestDateTime: z.coerce.date().nullish(),
});

export const ModelManagementAlarmsAgentSchema: z.ZodObject<Properties<ModelManagementAlarmsAgent>> = z.object({
  __typename: z.literal('ModelManagementAlarms_Agent').optional(),
  alarmCategory: z.string().nullish(),
  alarmCode: z.json().nullish(),
  alarmCodeExternalId: z.string().nullish(),
  alarmCriticality: z.string().nullish(),
  alarmFlags: z.string().nullish(),
  alarmName: z.string().nullish(),
  alarmPriority: z.string().nullish(),
  customWorkflowAlarmMessage: z.string().nullish(),
  endDateTime: z.coerce.date().nullish(),
  entityExternalId: z.string(),
  entityName: z.string(),
  entityType: z.string(),
  startDateTime: z.coerce.date(),
  subCategory: z.string().nullish(),
  subWorkflowName: z.string().nullish(),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  workflowCode: z.string().nullish(),
  workflowName: z.string().nullish(),
});

export const InjectionAllocationFactorSchema: z.ZodObject<Properties<InjectionAllocationFactor>> = z.object({
  __typename: z.literal('Injection_Allocation_Factor').optional(),
  allocationFactor: z.float32().nullish(),
  effectiveDate: z.coerce.date().nullish(),
  injectorString: z.lazy(() => StringAssetSchema.nullish()),
  producerString: z.lazy(() => StringAssetSchema.nullish()),
  source: z.string().nullish(),
});

export const InjectionAlarmsAgentSchema: z.ZodObject<Properties<InjectionAlarmsAgent>> = z.object({
  __typename: z.literal('InjectionAlarms_Agent').optional(),
  alarmCategory: z.string().nullish(),
  alarmCode: z.json().nullish(),
  alarmCodeExternalId: z.string().nullish(),
  alarmCounter: z.number().nullish(),
  alarmCriticality: z.string().nullish(),
  alarmFlags: z.string().nullish(),
  alarmName: z.string().nullish(),
  alarmPriority: z.string().nullish(),
  customWorkflowAlarmMessage: z.string().nullish(),
  endDateTime: z.coerce.date().nullish(),
  entityExternalId: z.string(),
  entityName: z.string(),
  entityType: z.string(),
  startDateTime: z.coerce.date(),
  subCategory: z.string().nullish(),
  subWorkflowName: z.string().nullish(),
  ticketId: z.string().nullish(),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  workflowCode: z.string().nullish(),
  workflowName: z.string().nullish(),
});

export const InjPressGuidelineStringAgentSchema: z.ZodObject<Properties<InjPressGuidelineStringAgent>> = z.object({
  __typename: z.literal('InjPressGuideline_String_Agent').optional(),
  giMaxBHIP: z.float32().nullish(),
  giMaxInjRate: z.float32().nullish(),
  giMaxWHIP: z.float32().nullish(),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  wiMaxBHIP: z.float32().nullish(),
  wiMaxInjRate: z.float32().nullish(),
  wiMaxWHIP: z.float32().nullish(),
});

export const InjPressGuidelineStringSchema: z.ZodObject<Properties<InjPressGuidelineString>> = z.object({
  __typename: z.literal('InjPressGuideline_String').optional(),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  giMaxBHIP: z.float32().nullish(),
  giMaxInjRate: z.float32().nullish(),
  giMaxWHIP: z.float32().nullish(),
  wiMaxBHIP: z.float32().nullish(),
  wiMaxInjRate: z.float32().nullish(),
  wiMaxWHIP: z.float32().nullish(),
});

export const GasLiftAlarmsAgentSchema: z.ZodObject<Properties<GasLiftAlarmsAgent>> = z.object({
  __typename: z.literal('GasLiftAlarms_Agent').optional(),
  alarmCategory: z.string().nullish(),
  alarmCode: z.json().nullish(),
  alarmCodeExternalId: z.string().nullish(),
  alarmCounter: z.number().nullish(),
  alarmCriticality: z.string().nullish(),
  alarmFlags: z.string().nullish(),
  alarmName: z.string().nullish(),
  alarmPriority: z.string().nullish(),
  customWorkflowAlarmMessage: z.string().nullish(),
  endDateTime: z.coerce.date().nullish(),
  entityExternalId: z.string(),
  entityName: z.string(),
  entityType: z.string(),
  startDateTime: z.coerce.date(),
  subCategory: z.string().nullish(),
  subWorkflowName: z.string().nullish(),
  ticketId: z.string().nullish(),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  workflowCode: z.string().nullish(),
  workflowName: z.string().nullish(),
});

export const GlValveDataSchema: z.ZodObject<Properties<GlValveData>> = z.object({
  __typename: z.literal('GL_Valve_Data').optional(),
  domePressure: z.float32().nullish(),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  field: z.lazy(() => FieldSchema.nullish()),
  gasLiftMandrel: z.number().nullish(),
  glPortSize: z.number().nullish(),
  glValveMaterial: z.string().nullish(),
  glValveOrificeSeries: z.string().nullish(),
  glValveSize: z.float32().nullish(),
  installationDate: z.coerce.date().nullish(),
  measuredDepth: z.float32().nullish(),
  rValue: z.number().nullish(),
  testRackOpeningPressure: z.float32().nullish(),
  trueVerticalDepth: z.float32().nullish(),
  type: z.string().nullish(),
});

export const FormationVolumeFactorSchema: z.ZodObject<Properties<FormationVolumeFactor>> = z.object({
  __typename: z.literal('Formation_Volume_Factor').optional(),
  bGas: z.float32().nullish(),
  bGasInjector: z.float32().nullish(),
  bOil: z.float32().nullish(),
  bWater: z.float32().nullish(),
  bWaterInjector: z.float32().nullish(),
  effectiveDate: z.coerce.date().nullish(),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  pb: z.float32().nullish(),
  pressure: z.float32().nullish(),
  reservoir: z.lazy(() => ReservoirSchema.nullish()),
  rs: z.float32().nullish(),
  temperature: z.float32().nullish(),
});

export const FlowAssuranceAlarmsAgentSchema: z.ZodObject<Properties<FlowAssuranceAlarmsAgent>> = z.object({
  __typename: z.literal('FlowAssuranceAlarms_Agent').optional(),
  alarmCategory: z.string().nullish(),
  alarmCode: z.json().nullish(),
  alarmCodeExternalId: z.string().nullish(),
  alarmCriticality: z.string().nullish(),
  alarmFlags: z.string().nullish(),
  alarmName: z.string().nullish(),
  alarmPriority: z.string().nullish(),
  customWorkflowAlarmMessage: z.string().nullish(),
  endDateTime: z.coerce.date().nullish(),
  entityExternalId: z.string(),
  entityName: z.string(),
  entityType: z.string(),
  startDateTime: z.coerce.date(),
  subCategory: z.string().nullish(),
  subWorkflowName: z.string().nullish(),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  workflowCode: z.string().nullish(),
  workflowName: z.string().nullish(),
});

export const FlatHierarchyAgentSchema: z.ZodObject<Properties<FlatHierarchyAgent>> = z.object({
  __typename: z.literal('FlatHierarchy_Agent').optional(),
  asset: z.lazy(() => AssetSchema.nullish()),
  company: z.lazy(() => CompanySchema.nullish()),
  endDateTime: z.coerce.date().nullish(),
  field: z.lazy(() => FieldSchema.nullish()),
  location: z.lazy(() => LocationSchema.nullish()),
  reservoir: z.lazy(() => ReservoirSchema.nullish()),
  startDateTime: z.coerce.date().nullish(),
  string: z.lazy(() => StringAssetSchema.nullish()),
  well: z.lazy(() => WellSchema.nullish()),
});

export const FlatHierarchySchema: z.ZodObject<Properties<FlatHierarchy>> = z.object({
  __typename: z.literal('FlatHierarchy').optional(),
  asset: z.lazy(() => AssetSchema.nullish()),
  company: z.lazy(() => CompanySchema.nullish()),
  endDateTime: z.coerce.date().nullish(),
  field: z.lazy(() => FieldSchema.nullish()),
  location: z.lazy(() => LocationSchema.nullish()),
  reservoir: z.lazy(() => ReservoirSchema.nullish()),
  startDateTime: z.coerce.date().nullish(),
  string: z.lazy(() => StringAssetSchema.nullish()),
  well: z.lazy(() => WellSchema.nullish()),
});

export const EspPumpDetailsSchema: z.ZodObject<Properties<EspPumpDetails>> = z.object({
  __typename: z.literal('ESP_Pump_Details').optional(),
  adcoInstallation: z.float32().nullish(),
  aghMatl: z.string().nullish(),
  aghModel: z.string().nullish(),
  agh_nORu: z.string().nullish(),
  bohMatl: z.string().nullish(),
  bohSeries: z.float32().nullish(),
  bohThd: z.string().nullish(),
  cableSize: z.float32().nullish(),
  cableTotalLength: z.float32().nullish(),
  cableType: z.string().nullish(),
  cable_nORu: z.string().nullish(),
  comments: z.string().nullish(),
  commissionDate: z.coerce.date().nullish(),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  espComponent: z.string().nullish(),
  espSensorDepth_MD_ft: z.float32().nullish(),
  espSensorDepth_TVD_ft: z.float32().nullish(),
  field: z.lazy(() => FieldSchema.nullish()),
  intakeVgsaMatl: z.string().nullish(),
  intakeVgsaModel: z.string().nullish(),
  intakeVgsaSeries: z.float32().nullish(),
  intakeVgsa_nORu: z.string().nullish(),
  mle: z.float32().nullish(),
  mleSeries: z.float32().nullish(),
  mleType: z.string().nullish(),
  monitorType: z.string().nullish(),
  monitor_nORu: z.string().nullish(),
  motorA: z.float32().nullish(),
  motorHsg: z.float32().nullish(),
  motorMatl: z.string().nullish(),
  motorRefW: z.float32().nullish(),
  motorSeries: z.float32().nullish(),
  motorTotalPower: z.float32().nullish(),
  motorTotalV: z.float32().nullish(),
  motor_nORu: z.string().nullish(),
  nORu: z.string().nullish(),
  numberOfPoles: z.number().nullish(),
  packer: z.string().nullish(),
  panelVsdA: z.float32().nullish(),
  panelVsdKVA: z.float32().nullish(),
  panelVsdType: z.string().nullish(),
  protectorMatl: z.string().nullish(),
  protectorModel: z.string().nullish(),
  protectorSeries: z.float32().nullish(),
  protector_nORu: z.string().nullish(),
  pullDate: z.coerce.date().nullish(),
  pullReason: z.string().nullish(),
  pumpAr: z.string().nullish(),
  pumpHsg: z.float32().nullish(),
  pumpMatl: z.string().nullish(),
  pumpModel: z.string().nullish(),
  pumpSeries: z.float32().nullish(),
  pump_nORu: z.string().nullish(),
  rootCause: z.string().nullish(),
  runDate: z.coerce.date().nullish(),
  status: z.string().nullish(),
  stopORfailureDate: z.coerce.date().nullish(),
  supplyCompany: z.string().nullish(),
  tol_MD: z.float32().nullish(),
  tol_TVD: z.float32().nullish(),
  topReservoirDepth_MD: z.float32().nullish(),
  topReservoirDepth_TVD: z.float32().nullish(),
  totalStages: z.float32().nullish(),
  transformerA: z.float32().nullish(),
  transformerComments: z.string().nullish(),
  transformerKVA: z.float32().nullish(),
  transformerTapSetting: z.string().nullish(),
  transformerVoltageRatio: z.float32().nullish(),
  wellInstallationNumber: z.float32().nullish(),
  yTool: z.string().nullish(),
});

export const EspAlarmsAgentSchema: z.ZodObject<Properties<EspAlarmsAgent>> = z.object({
  __typename: z.literal('ESPAlarms_Agent').optional(),
  alarmCategory: z.string().nullish(),
  alarmCode: z.json().nullish(),
  alarmCodeExternalId: z.string().nullish(),
  alarmCounter: z.number().nullish(),
  alarmCriticality: z.string().nullish(),
  alarmFlags: z.string().nullish(),
  alarmName: z.string().nullish(),
  alarmPriority: z.string().nullish(),
  customWorkflowAlarmMessage: z.string().nullish(),
  endDateTime: z.coerce.date().nullish(),
  entityExternalId: z.string(),
  entityName: z.string(),
  entityType: z.string(),
  startDateTime: z.coerce.date(),
  subCategory: z.string().nullish(),
  subWorkflowName: z.string().nullish(),
  ticketId: z.string().nullish(),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  workflowCode: z.string().nullish(),
  workflowName: z.string().nullish(),
});

export const TimeSeriesSchema: z.ZodObject<Properties<TimeSeries>> = z.object({
  __typename: z.literal('TimeSeries').optional(),
  externalId: z.string().nullish(),
  id: z.int32().nullish(),
});

export const Wf3OutputsStringSchema: z.ZodObject<Properties<Wf3OutputsString>> = z.object({
  __typename: z.literal('Wf3Outputs_String').optional(),
  chokeBestGor: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeBestWc: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeBestWgr: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  modelEspWf: z.lazy(() => TimeSeriesSchema.nullish()),
  modelEspWfPercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelEstimatedFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  modelEstimatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelEstimatedLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelEstimatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelEstimatedPdgPress: z.lazy(() => TimeSeriesSchema.nullish()),
  modelEstimatedPdp: z.lazy(() => TimeSeriesSchema.nullish()),
  modelEstimatedPip: z.lazy(() => TimeSeriesSchema.nullish()),
  modelEstimatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelGlOrificeSize: z.lazy(() => TimeSeriesSchema.nullish()),
  modelGlOrificeSizePercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelInjectivityIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  modelInjectivityIndexPercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelIprC: z.lazy(() => TimeSeriesSchema.nullish()),
  modelIprN: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMinStableRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelNewFileId: z.int64().nullish(),
  modelOriginalFileId: z.int64().nullish(),
  modelProductivityIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  modelProductivityIndexPercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelReservoirModel: z.lazy(() => TimeSeriesSchema.nullish()),
  modelReservoirPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  modelReservoirPressurePercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelRevisionExternalId: z.lazy(() => TimeSeriesSchema.nullish()),
  modelRevisionNumber: z.lazy(() => TimeSeriesSchema.nullish()),
  modelStabilityFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  modelStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  modelUval: z.lazy(() => TimeSeriesSchema.nullish()),
  modelVlpCorrelation: z.lazy(() => TimeSeriesSchema.nullish()),
  modelVlpModel: z.coerce.date().nullish(),
  modelVlpParameter1: z.lazy(() => TimeSeriesSchema.nullish()),
  modelVlpParameter1PercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelVlpParameter2: z.lazy(() => TimeSeriesSchema.nullish()),
  modelVlpParameter2PercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestChp: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestEspFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestGlInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestGor: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestPdgPress: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestTimestamp: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestWc: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestWhp: z.lazy(() => TimeSeriesSchema.nullish()),
  newFileId: z.lazy(() => TimeSeriesSchema.nullish()),
  originalFileId: z.lazy(() => TimeSeriesSchema.nullish()),
  vlpBestGor: z.lazy(() => TimeSeriesSchema.nullish()),
  vlpBestWc: z.lazy(() => TimeSeriesSchema.nullish()),
  vlpBestWgr: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const WellChokeMappingSchema: z.ZodObject<Properties<WellChokeMapping>> = z.object({
  __typename: z.literal('Well_Choke_Mapping').optional(),
  choketype: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  gasLiftChokeType: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const WellTestReservoirAnalysisAgentSchema: z.ZodObject<Properties<WellTestReservoirAnalysisAgent>> = z.object({
  __typename: z.literal('WellTest_ReservoirAnalysis_Agent').optional(),
  modelInjectivityIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  modelInjectivityIndexPercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMinStableRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelProductivityIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  modelProductivityIndexPercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelReservoirPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  modelReservoirPressurePercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelStabilityFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  modelStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestTimestamp: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const WellTestRawSchema: z.ZodObject<Properties<WellTestRaw>> = z.object({
  __typename: z.literal('WellTest_Raw').optional(),
  comments: z.lazy(() => TimeSeriesSchema.nullish()),
  composition: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  fluidProperties: z.lazy(() => TimeSeriesSchema.nullish()),
  modelComposition: z.lazy(() => TimeSeriesSchema.nullish()),
  ptsDateTime: z.lazy(() => TimeSeriesSchema.nullish()),
  sampleDateTime: z.lazy(() => TimeSeriesSchema.nullish()),
  stablePeriodEndDate: z.lazy(() => TimeSeriesSchema.nullish()),
  stablePeriodStartDate: z.lazy(() => TimeSeriesSchema.nullish()),
  validatedBy: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestApprovedAllocationFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestArtificialLiftType: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestBottomHolePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestBottomHoleTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestCGR: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestCasingHeadPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestCasingHeadTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestChokeSize: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestDuration: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEgorVendorStdGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEgorVendorStdOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEgorVendorStdWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEndDate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspMotorCurrent: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspMotorPower: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspMotorVoltage: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspPumpDischargePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspPumpFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspPumpIntakePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspPumpIntakeTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestFlowlinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestFlowlineTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasDensityInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasLiftVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasRateInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasRatePts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGlFlControlValvOutletPres: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGlFlControlValveInletPres: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGlFlControlValveInletTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGlInjectionChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGorInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGorPts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestLiquidRatePts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestMpfmName: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilDensityInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilRateInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilRatePts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestStartDate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestStringFunction: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTestMethod: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTestSeparatorLinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTestSeparatorLineTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTestType: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTestTypeDesc: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTotalGorStd: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTotalMassFlowRateGas: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTotalMassFlowRateOil: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTotalMassFlowRateWater: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestValidationFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWGR: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterCut: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterCutInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterCutPts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterRateInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterRatePts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWellheadPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWellheadTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const WellTestModelParametersAgentSchema: z.ZodObject<Properties<WellTestModelParametersAgent>> = z.object({
  __typename: z.literal('WellTest_ModelParameters_Agent').optional(),
  hasProsperModel: z.boolean().nullish(),
  modelEspWf: z.lazy(() => TimeSeriesSchema.nullish()),
  modelEspWfPercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelGlOrificeSize: z.lazy(() => TimeSeriesSchema.nullish()),
  modelGlOrificeSizePercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelIprC: z.lazy(() => TimeSeriesSchema.nullish()),
  modelIprN: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  modelReservoirModel: z.lazy(() => TimeSeriesSchema.nullish()),
  modelRevisionNumber: z.lazy(() => TimeSeriesSchema.nullish()),
  modelUval: z.lazy(() => TimeSeriesSchema.nullish()),
  modelVlpCorrelation: z.lazy(() => TimeSeriesSchema.nullish()),
  modelVlpParameter1: z.lazy(() => TimeSeriesSchema.nullish()),
  modelVlpParameter1PercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelVlpParameter2: z.lazy(() => TimeSeriesSchema.nullish()),
  modelVlpParameter2PercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestEspFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestGlInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  prosperModelExternalId: z.string().nullish(),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const WellTestOutputsStringSchema: z.ZodObject<Properties<WellTestOutputsString>> = z.object({
  __typename: z.literal('WellTestOutputs_String').optional(),
  cdValue: z.lazy(() => TimeSeriesSchema.nullish()),
  cgrLC: z.lazy(() => TimeSeriesSchema.nullish()),
  cgrSC: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAlarmsCode: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeMatchedgasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeMatchedliquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeSize: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeSizeInch: z.lazy(() => TimeSeriesSchema.nullish()),
  chp: z.lazy(() => TimeSeriesSchema.nullish()),
  dhgp: z.lazy(() => TimeSeriesSchema.nullish()),
  dhgt: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  espwear: z.lazy(() => TimeSeriesSchema.nullish()),
  flp: z.lazy(() => TimeSeriesSchema.nullish()),
  flt: z.lazy(() => TimeSeriesSchema.nullish()),
  gasDensityLC: z.lazy(() => TimeSeriesSchema.nullish()),
  gasDensitySC: z.lazy(() => TimeSeriesSchema.nullish()),
  gasMassFlowRateLC: z.lazy(() => TimeSeriesSchema.nullish()),
  gasMassFlowRateSC: z.lazy(() => TimeSeriesSchema.nullish()),
  gasRateLC: z.lazy(() => TimeSeriesSchema.nullish()),
  gasRateSC: z.lazy(() => TimeSeriesSchema.nullish()),
  gasVolumeFractionLC: z.lazy(() => TimeSeriesSchema.nullish()),
  glFcvChokeSize: z.lazy(() => TimeSeriesSchema.nullish()),
  glFcvInletPress: z.lazy(() => TimeSeriesSchema.nullish()),
  glFcvInletTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  glFcvOutletPress: z.lazy(() => TimeSeriesSchema.nullish()),
  glFcvOutletTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  glinjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  gorLC: z.lazy(() => TimeSeriesSchema.nullish()),
  historicalAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  historicalAlarmsCode: z.lazy(() => TimeSeriesSchema.nullish()),
  liquidRateLc: z.lazy(() => TimeSeriesSchema.nullish()),
  liquidRateSc: z.lazy(() => TimeSeriesSchema.nullish()),
  modelAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  modelAlarmsCode: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedgasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedliquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedoilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedwaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMinStableRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelProductivityIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  modelReservoirModel: z.lazy(() => TimeSeriesSchema.nullish()),
  modelReservoirPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  modelStabilityFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  modelVlpModel: z.coerce.date().nullish(),
  modelWellTestTimestamp: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfm: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmDifferentialPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmLinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmLineTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  oilDensityLC: z.lazy(() => TimeSeriesSchema.nullish()),
  oilDensitySC: z.lazy(() => TimeSeriesSchema.nullish()),
  oilMassFlowRateLC: z.lazy(() => TimeSeriesSchema.nullish()),
  oilMassFlowRateSC: z.lazy(() => TimeSeriesSchema.nullish()),
  oilRateLC: z.lazy(() => TimeSeriesSchema.nullish()),
  oilRateSC: z.lazy(() => TimeSeriesSchema.nullish()),
  oilVolumeFractionLC: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpCurrent: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpDischargePress: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpDischargeTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpIntakePress: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpIntakeTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpMotorTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpPower: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpVibration: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpVoltage: z.lazy(() => TimeSeriesSchema.nullish()),
  pvtAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  pvtAlarmsCode: z.lazy(() => TimeSeriesSchema.nullish()),
  stablePeriodEndDate: z.lazy(() => TimeSeriesSchema.nullish()),
  stablePeriodStartDate: z.lazy(() => TimeSeriesSchema.nullish()),
  totalGorSC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterCutLC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterCutSC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterDensityLC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterDensitySC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterMassFlowRateLC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterMassFlowRateSC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterRateLC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterRateSC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterVolumeFractionLC: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEndDate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestStartDate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestStartDateDH: z.lazy(() => TimeSeriesSchema.nullish()),
  wgrLC: z.lazy(() => TimeSeriesSchema.nullish()),
  wgrSC: z.lazy(() => TimeSeriesSchema.nullish()),
  whp: z.lazy(() => TimeSeriesSchema.nullish()),
  wht: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const WellTestInputsStringSchema: z.ZodObject<Properties<WellTestInputsString>> = z.object({
  __typename: z.literal('WellTestInputs_String').optional(),
  cgrLC: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAlarmsCode: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeMatchedliquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  comments: z.lazy(() => TimeSeriesSchema.nullish()),
  composition: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  espwear: z.lazy(() => TimeSeriesSchema.nullish()),
  fluidProperties: z.lazy(() => TimeSeriesSchema.nullish()),
  formationGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  gasDensityLC: z.lazy(() => TimeSeriesSchema.nullish()),
  gasDensitySC: z.lazy(() => TimeSeriesSchema.nullish()),
  gasMassFlowRateLC: z.lazy(() => TimeSeriesSchema.nullish()),
  gasMassFlowRateSC: z.lazy(() => TimeSeriesSchema.nullish()),
  gasVolumeFractionLC: z.lazy(() => TimeSeriesSchema.nullish()),
  glFcvOutletTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  glinjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  historicalAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  historicalAlarmsCode: z.lazy(() => TimeSeriesSchema.nullish()),
  lastUpdatedByStablePeriod: z.lazy(() => TimeSeriesSchema.nullish()),
  lastUpdatedByWellTest: z.lazy(() => TimeSeriesSchema.nullish()),
  liquidRateLc: z.lazy(() => TimeSeriesSchema.nullish()),
  liquidRateSc: z.lazy(() => TimeSeriesSchema.nullish()),
  modelAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  modelAlarmsCode: z.lazy(() => TimeSeriesSchema.nullish()),
  modelComposition: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedgasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedliquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedoilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedwaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMinStableRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelProductivityIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  modelReservoirModel: z.lazy(() => TimeSeriesSchema.nullish()),
  modelReservoirPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  modelStabilityFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  modelVlpModel: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestTimestamp: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmDifferentialPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmLinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmLineTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  oilDensityLC: z.lazy(() => TimeSeriesSchema.nullish()),
  oilDensitySC: z.lazy(() => TimeSeriesSchema.nullish()),
  oilMassFlowRateLC: z.lazy(() => TimeSeriesSchema.nullish()),
  oilMassFlowRateSC: z.lazy(() => TimeSeriesSchema.nullish()),
  oilVolumeFractionLC: z.lazy(() => TimeSeriesSchema.nullish()),
  ptsDateTime: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpDischargeTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpMotorTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpPower: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpVibration: z.lazy(() => TimeSeriesSchema.nullish()),
  pvtAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  sampleDateTime: z.lazy(() => TimeSeriesSchema.nullish()),
  stablePeriodEndDate: z.lazy(() => TimeSeriesSchema.nullish()),
  stablePeriodStartDate: z.lazy(() => TimeSeriesSchema.nullish()),
  validatedBy: z.lazy(() => TimeSeriesSchema.nullish()),
  waterDensityLC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterDensitySC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterMassFlowRateLC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterMassFlowRateSC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterVolumeFractionLC: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestApprovedAllocationFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestArtificialLiftType: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestBottomHolePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestBottomHoleTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestCGR: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestCasingHeadPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestCasingHeadTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestChokeSize: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestDuration: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEgorVendorStdGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEgorVendorStdOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEgorVendorStdWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEndDate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspMotorCurrent: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspMotorPower: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspMotorVoltage: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspPumpDischargePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspPumpFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspPumpIntakePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspPumpIntakeTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestFlowlinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestFlowlineTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasDensityInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasLiftVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasRateInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasRatePts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGlFlControlValvOutletPres: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGlFlControlValveInletPres: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGlFlControlValveInletTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGlInjectionChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGlInjectionChokeSize: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGorInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGorPts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestLiquidRateLC: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestLiquidRatePts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestLiquidRateSC: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestMpfmName: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilDensityInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilRateInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilRatePts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestStartDate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestStartDateDH: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestStringFunction: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTestMethod: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTestSeparatorLinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTestSeparatorLineTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTestType: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTestTypeDesc: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTotalGorStd: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTotalMassFlowRateGas: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTotalMassFlowRateOil: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTotalMassFlowRateWater: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestValidationFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWGR: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterCut: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterCutInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterCutPts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterRateInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterRatePts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWellheadPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWellheadTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wgrLC: z.lazy(() => TimeSeriesSchema.nullish()),
  wlrLC: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const WellTestGaugeStringSchema: z.ZodObject<Properties<WellTestGaugeString>> = z.object({
  __typename: z.literal('WellTestGauge_String').optional(),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  lowerDatumDepth: z.lazy(() => TimeSeriesSchema.nullish()),
  lowerGaugeDepth: z.lazy(() => TimeSeriesSchema.nullish()),
  lowerGaugePosition: z.lazy(() => TimeSeriesSchema.nullish()),
  lowerProductivityIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  lowerProductivityIndexSS: z.lazy(() => TimeSeriesSchema.nullish()),
  lowerResPressAtDatum: z.lazy(() => TimeSeriesSchema.nullish()),
  lowerResPressAtGauge: z.lazy(() => TimeSeriesSchema.nullish()),
  lowerSelectedGradient: z.lazy(() => TimeSeriesSchema.nullish()),
  lowerTestType: z.lazy(() => TimeSeriesSchema.nullish()),
  naDatumDepth: z.lazy(() => TimeSeriesSchema.nullish()),
  naGaugeDepth: z.lazy(() => TimeSeriesSchema.nullish()),
  naGaugePosition: z.lazy(() => TimeSeriesSchema.nullish()),
  naProductivityIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  naProductivityIndexSS: z.lazy(() => TimeSeriesSchema.nullish()),
  naResPressAtDatum: z.lazy(() => TimeSeriesSchema.nullish()),
  naResPressAtGauge: z.lazy(() => TimeSeriesSchema.nullish()),
  naSelectedGradient: z.lazy(() => TimeSeriesSchema.nullish()),
  naTestType: z.lazy(() => TimeSeriesSchema.nullish()),
  upperDatumDepth: z.lazy(() => TimeSeriesSchema.nullish()),
  upperGaugeDepth: z.lazy(() => TimeSeriesSchema.nullish()),
  upperGaugePosition: z.lazy(() => TimeSeriesSchema.nullish()),
  upperProductivityIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  upperProductivityIndexSS: z.lazy(() => TimeSeriesSchema.nullish()),
  upperResPressAtDatum: z.lazy(() => TimeSeriesSchema.nullish()),
  upperResPressAtGauge: z.lazy(() => TimeSeriesSchema.nullish()),
  upperSelectedGradient: z.lazy(() => TimeSeriesSchema.nullish()),
  upperTestType: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const WellTestAnalysisAgentSchema: z.ZodObject<Properties<WellTestAnalysisAgent>> = z.object({
  __typename: z.literal('WellTestAnalysis_Agent').optional(),
  modelEstimatedFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  modelEstimatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelEstimatedLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelEstimatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelEstimatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelInjectivityIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  modelInjectivityIndexPercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelProductivityIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  modelProductivityIndexPercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelReservoirPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  modelReservoirPressurePercentChange: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestChp: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestGor: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestPdgPress: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestTimestamp: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestWc: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestWhp: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const WellStatusStringAgentSchema: z.ZodObject<Properties<WellStatusStringAgent>> = z.object({
  __typename: z.literal('WellStatus_String_Agent').optional(),
  hoursOnline: z.lazy(() => TimeSeriesSchema.nullish()),
  instrumented: z.float32().nullish(),
  liftType: z.lazy(() => TimeSeriesSchema.nullish()),
  onlineStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  onlineStatusReason: z.lazy(() => TimeSeriesSchema.nullish()),
  pressureCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  pressureSource: z.lazy(() => TimeSeriesSchema.nullish()),
  product: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirPressureDatum: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirPressureMidPerforation: z.lazy(() => TimeSeriesSchema.nullish()),
  sluggingStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  steadyStateStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  subSurfaceSafetyValveCloseState: z.number().nullish(),
  surfaceSafetyValveCloseState: z.number().nullish(),
  wag: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  wellTestValidation: z.lazy(() => TimeSeriesSchema.nullish()),
  wellType: z.lazy(() => TimeSeriesSchema.nullish()),
  wingValveCloseState: z.number().nullish(),
});

export const WellOutputsStringSchema: z.ZodObject<Properties<WellOutputsString>> = z.object({
  __typename: z.literal('WellOutputs_String').optional(),
  calcFVF: z.lazy(() => TimeSeriesSchema.nullish()),
  calcGasFVF: z.lazy(() => TimeSeriesSchema.nullish()),
  calcGasViscosity: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAnalysisFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAnalysisGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAnalysisLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAnalysisOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAnalysisStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAnalysisWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeCdCalc: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeSizeCalc: z.lazy(() => TimeSeriesSchema.nullish()),
  cumulativeGasInjPress: z.lazy(() => TimeSeriesSchema.nullish()),
  cumulativeGasInjVol: z.lazy(() => TimeSeriesSchema.nullish()),
  cumulativeWaterInjPress: z.lazy(() => TimeSeriesSchema.nullish()),
  cumulativeWaterInjVol: z.lazy(() => TimeSeriesSchema.nullish()),
  curveAnalysisFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  curveAnalysisGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  curveAnalysisLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  curveAnalysisOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  curveAnalysisWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  dataAnalysisFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  dataAnalysisGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  dataAnalysisLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  dataAnalysisOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  dataAnalysisWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeGasInjectionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeGasProductionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeOilProductionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeWaterInjectionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeWaterProductionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  espqlAnalysisStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  giBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  giRate: z.lazy(() => TimeSeriesSchema.nullish()),
  giTargetRate: z.lazy(() => TimeSeriesSchema.nullish()),
  giTechnicalRate: z.lazy(() => TimeSeriesSchema.nullish()),
  giWHP: z.lazy(() => TimeSeriesSchema.nullish()),
  glChokeCdCalc: z.lazy(() => TimeSeriesSchema.nullish()),
  glChokeSizeCalc: z.lazy(() => TimeSeriesSchema.nullish()),
  glirAllocated: z.lazy(() => TimeSeriesSchema.nullish()),
  glirChokeEquation: z.lazy(() => TimeSeriesSchema.nullish()),
  glirMeasured: z.lazy(() => TimeSeriesSchema.nullish()),
  glirNetworkSimulation: z.lazy(() => TimeSeriesSchema.nullish()),
  glirSelected: z.lazy(() => TimeSeriesSchema.nullish()),
  glirSelectedType: z.lazy(() => TimeSeriesSchema.nullish()),
  glqlAnalysisStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  grdAnalysisStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  hallInterpretation: z.lazy(() => TimeSeriesSchema.nullish()),
  hallLine: z.lazy(() => TimeSeriesSchema.nullish()),
  hoursOnline: z.lazy(() => TimeSeriesSchema.nullish()),
  injectionEfficiency: z.lazy(() => TimeSeriesSchema.nullish()),
  injectionEfficiencyFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  injectionEfficiencyRank: z.lazy(() => TimeSeriesSchema.nullish()),
  injectivityIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  instrumented: z.float32().nullish(),
  iprAnalysisFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  iprAnalysisGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  iprAnalysisLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  iprAnalysisOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  iprAnalysisWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  liftType: z.lazy(() => TimeSeriesSchema.nullish()),
  motorEfficiency: z.lazy(() => TimeSeriesSchema.nullish()),
  motorLoad: z.lazy(() => TimeSeriesSchema.nullish()),
  onlineStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  onlineStatusReason: z.lazy(() => TimeSeriesSchema.nullish()),
  pressureCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  pressureSource: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityMethod: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  priotiryWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  product: z.lazy(() => TimeSeriesSchema.nullish()),
  productivityIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  prosperLiftType: z.lazy(() => TimeSeriesSchema.nullish()),
  prosperProduct: z.lazy(() => TimeSeriesSchema.nullish()),
  prosperWag: z.lazy(() => TimeSeriesSchema.nullish()),
  prosperWellType: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpAvgRate: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpHead: z.lazy(() => TimeSeriesSchema.nullish()),
  pvt_AlarmCode: z.lazy(() => TimeSeriesSchema.nullish()),
  qliqDelta: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirPressureDatum: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirPressureMidPerforation: z.lazy(() => TimeSeriesSchema.nullish()),
  simulationChokeId: z.lazy(() => TimeSeriesSchema.nullish()),
  simulationCurveInput: z.lazy(() => TimeSeriesSchema.nullish()),
  simulationId: z.lazy(() => TimeSeriesSchema.nullish()),
  simulationIprInput: z.lazy(() => TimeSeriesSchema.nullish()),
  simulationVlpInput: z.lazy(() => TimeSeriesSchema.nullish()),
  sluggingStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  steadyStateStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  subSurfaceSafetyValveCloseState: z.number().nullish(),
  surfaceSafetyValveCloseState: z.number().nullish(),
  systemAnalysisFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  systemAnalysisGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  systemAnalysisLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  systemAnalysisOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  systemAnalysisStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  systemAnalysisWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  vlpAnalysisFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  vlpAnalysisGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  vlpAnalysisLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  vlpAnalysisOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  vlpAnalysisWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  wag: z.lazy(() => TimeSeriesSchema.nullish()),
  wellPerformance: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestValidation: z.lazy(() => TimeSeriesSchema.nullish()),
  wellType: z.lazy(() => TimeSeriesSchema.nullish()),
  wiBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  wiRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wiTargetRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wiTechnicalRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wiWHP: z.lazy(() => TimeSeriesSchema.nullish()),
  wingValveCloseState: z.number().nullish(),
});

export const WellOutputsExt_1StringSchema: z.ZodObject<Properties<WellOutputsExt_1String>> = z.object({
  __typename: z.literal('WellOutputs_Ext_1_String').optional(),
  dataDrivenGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  dataDrivenLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  dataDrivenOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  dataDrivenWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  giBHPCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  giTargetRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  giTechnicalRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  giWHPCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  wiBHPCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  wiTargetRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  wiTechnicalRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  wiWHPCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const WellInputsStringSchema: z.ZodObject<Properties<WellInputsString>> = z.object({
  __typename: z.literal('WellInputs_String').optional(),
  annulusPress: z.lazy(() => TimeSeriesSchema.nullish()),
  bottomHolePress: z.lazy(() => TimeSeriesSchema.nullish()),
  bottomHoleTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  casingHeadPress: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeDownstreamPressure1: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeDownstreamPressure2: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeSize: z.lazy(() => TimeSeriesSchema.nullish()),
  controlValve: z.lazy(() => TimeSeriesSchema.nullish()),
  depthSensor: z.lazy(() => TimeSeriesSchema.nullish()),
  downstreamPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  flowLinePress: z.lazy(() => TimeSeriesSchema.nullish()),
  flowLineTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  gasInjChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  gasInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
  gasInjWellheadPress: z.lazy(() => TimeSeriesSchema.nullish()),
  gasLiftFlowCVInletPress: z.lazy(() => TimeSeriesSchema.nullish()),
  gasLiftFlowCVInletTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  gasLiftFlowCVSize: z.lazy(() => TimeSeriesSchema.nullish()),
  gasLiftInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
  gasLiftInjTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  gasRateFlow: z.lazy(() => TimeSeriesSchema.nullish()),
  giHeaderPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  giHeaderTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  liftType: z.lazy(() => TimeSeriesSchema.nullish()),
  modelComposition: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialOilProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpCurrent: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpDischargePress: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpDischargeTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpIntakePress: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpIntakeTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpMotorTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpVibration: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpVoltage: z.lazy(() => TimeSeriesSchema.nullish()),
  sPress: z.lazy(() => TimeSeriesSchema.nullish()),
  subSurfaceSafetyValve: z.lazy(() => TimeSeriesSchema.nullish()),
  surfaceSafetyValve: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetOilProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  toProdHeader: z.lazy(() => TimeSeriesSchema.nullish()),
  toTestHeader: z.lazy(() => TimeSeriesSchema.nullish()),
  waterHeaderPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  waterInjChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  waterInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
  waterInjWellheadPress: z.lazy(() => TimeSeriesSchema.nullish()),
  wellHeadPress: z.lazy(() => TimeSeriesSchema.nullish()),
  wellHeadTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  wingValve: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const WaterAnalysisSchema: z.ZodObject<Properties<WaterAnalysis>> = z.object({
  __typename: z.literal('Water_Analysis').optional(),
  analysisDate: z.lazy(() => TimeSeriesSchema.nullish()),
  barium: z.lazy(() => TimeSeriesSchema.nullish()),
  bicarbonate: z.lazy(() => TimeSeriesSchema.nullish()),
  boron: z.lazy(() => TimeSeriesSchema.nullish()),
  bsw: z.lazy(() => TimeSeriesSchema.nullish()),
  calcium: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedTotalDisolvedSolids: z.lazy(() => TimeSeriesSchema.nullish()),
  carbonate: z.lazy(() => TimeSeriesSchema.nullish()),
  chloride: z.lazy(() => TimeSeriesSchema.nullish()),
  companyProgramRef: z.lazy(() => TimeSeriesSchema.nullish()),
  companySampleNo: z.lazy(() => TimeSeriesSchema.nullish()),
  dissolvedIron: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  h2s: z.lazy(() => TimeSeriesSchema.nullish()),
  hydroxide: z.lazy(() => TimeSeriesSchema.nullish()),
  id: z.lazy(() => TimeSeriesSchema.nullish()),
  iron: z.lazy(() => TimeSeriesSchema.nullish()),
  magnesium: z.lazy(() => TimeSeriesSchema.nullish()),
  measuredTotalDisolvedSolids: z.lazy(() => TimeSeriesSchema.nullish()),
  oilContentVol: z.lazy(() => TimeSeriesSchema.nullish()),
  ph: z.lazy(() => TimeSeriesSchema.nullish()),
  phTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  phosphorous: z.lazy(() => TimeSeriesSchema.nullish()),
  potassium: z.lazy(() => TimeSeriesSchema.nullish()),
  remarks: z.lazy(() => TimeSeriesSchema.nullish()),
  reportRef: z.lazy(() => TimeSeriesSchema.nullish()),
  resistivity: z.lazy(() => TimeSeriesSchema.nullish()),
  resistivityTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  salinity: z.lazy(() => TimeSeriesSchema.nullish()),
  sampleDate: z.lazy(() => TimeSeriesSchema.nullish()),
  sampleType: z.lazy(() => TimeSeriesSchema.nullish()),
  sgTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  sodium: z.lazy(() => TimeSeriesSchema.nullish()),
  solubility: z.lazy(() => TimeSeriesSchema.nullish()),
  specificGravity: z.lazy(() => TimeSeriesSchema.nullish()),
  strontium: z.lazy(() => TimeSeriesSchema.nullish()),
  sulphate: z.lazy(() => TimeSeriesSchema.nullish()),
  temperature: z.lazy(() => TimeSeriesSchema.nullish()),
  totalIron: z.lazy(() => TimeSeriesSchema.nullish()),
  totalSuspendedSolids: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const Wf05StringReservoirOutputsSchema: z.ZodObject<Properties<Wf05StringReservoirOutputs>> = z.object({
  __typename: z.literal('WF05_String_Reservoir_Outputs').optional(),
  allocatedWellInjectionGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  allocatedWellInjectionWaterVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  executionType: z.lazy(() => TimeSeriesSchema.nullish()),
  fieldName: z.lazy(() => FieldSchema.nullish()),
  linkString: z.string().nullish(),
  normalizedWeightFactorChoke: z.lazy(() => TimeSeriesSchema.nullish()),
  normalizedWeightFactorDataDriven: z.lazy(() => TimeSeriesSchema.nullish()),
  normalizedWeightFactorESP: z.lazy(() => TimeSeriesSchema.nullish()),
  normalizedWeightFactorIPR: z.lazy(() => TimeSeriesSchema.nullish()),
  normalizedWeightFactorSystemAnalysis: z.lazy(() => TimeSeriesSchema.nullish()),
  normalizedWeightFactorVLP: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAllocatedWellAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAllocatedWellNonAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAllocatedWellOilVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAllocatedWellWaterVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAverageAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAverageNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAverageWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMDataSourceFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMEstimatedWellAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMEstimatedWellNonAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMEstimatedWellOilVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMEstimatedWellWaterVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirName: z.lazy(() => ReservoirSchema.nullish()),
  vfmChokeAverageAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmChokeAverageNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmChokeAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmChokeAverageWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmDataDrivenAverageAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmDataDrivenAverageNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmDataDrivenAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmDataDrivenAverageWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmESPAverageAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmESPAverageNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmESPAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmESPAverageWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmIPRAverageAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmIPRAverageNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmIPRAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmIPRAverageWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmSystemAnalysisAverageAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmSystemAnalysisAverageAssociatedNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmSystemAnalysisAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmSystemAnalysisAverageWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmVLPAverageAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmVLPAverageNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmVLPAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmVLPAverageWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageDataSourceFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMAllocatedWellAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMAllocatedWellNonAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMAllocatedWellOilVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMAllocatedWellWaterVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMEstimatedWellAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMEstimatedWellNonAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMEstimatedWellOilVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMEstimatedWellWaterVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellUptime: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const Wf05StringOutputsSchema: z.ZodObject<Properties<Wf05StringOutputs>> = z.object({
  __typename: z.literal('WF05_String_Outputs').optional(),
  agProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  allocatedWellInjectionGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  allocatedWellInjectionGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  allocatedWellInjectionWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  allocatedWellInjectionWaterVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  averageGasInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  averageWaterInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  executionType: z.lazy(() => TimeSeriesSchema.nullish()),
  gasInjectioAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  gasProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  injectionRateDataSourceFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  isWag: z.lazy(() => TimeSeriesSchema.nullish()),
  nagProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  normalizedWeightFactorChoke: z.lazy(() => TimeSeriesSchema.nullish()),
  normalizedWeightFactorDataDriven: z.lazy(() => TimeSeriesSchema.nullish()),
  normalizedWeightFactorESP: z.lazy(() => TimeSeriesSchema.nullish()),
  normalizedWeightFactorIPR: z.lazy(() => TimeSeriesSchema.nullish()),
  normalizedWeightFactorSystemAnalysis: z.lazy(() => TimeSeriesSchema.nullish()),
  normalizedWeightFactorVLP: z.lazy(() => TimeSeriesSchema.nullish()),
  oilProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAllocatedWellAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAllocatedWellNonAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAllocatedWellOilVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAllocatedWellWaterVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAverageAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAverageNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAverageWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMDataSourceFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMEstimatedWellAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMEstimatedWellNonAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMEstimatedWellOilVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMEstimatedWellWaterVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmChokeAverageAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmChokeAverageNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmChokeAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmChokeAverageWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmDataDrivenAverageAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmDataDrivenAverageNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmDataDrivenAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmDataDrivenAverageWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmESPAverageAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmESPAverageNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmESPAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmESPAverageWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmIPRAverageAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmIPRAverageNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmIPRAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmIPRAverageWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmPreferredMethodAssociatedGasAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmPreferredMethodNonAssociatedGasAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmPreferredMethodOilAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmPreferredMethodWaterAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmSystemAnalysisAverageAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmSystemAnalysisAverageAssociatedNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmSystemAnalysisAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmSystemAnalysisAverageWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmVLPAverageAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmVLPAverageNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmVLPAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmVLPAverageWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmWeightedAverageAssociatedGasAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmWeightedAverageMethodOilAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmWeightedAverageNonAssociatedGasAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmWeightedAverageWaterAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
  waterInjectionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  waterProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageDataSourceFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMAllocatedWellAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMAllocatedWellNonAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMAllocatedWellOilVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMAllocatedWellWaterVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMEstimatedWellAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMEstimatedWellNonAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMEstimatedWellOilVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMEstimatedWellWaterVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellGasInjectionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  wellType: z.lazy(() => TimeSeriesSchema.nullish()),
  wellUptime: z.lazy(() => TimeSeriesSchema.nullish()),
  wellWaterInjectionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const Wf05FieldOutputsSchema: z.ZodObject<Properties<Wf05FieldOutputs>> = z.object({
  __typename: z.literal('WF05_Field_Outputs').optional(),
  agProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  dailyActualGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  dailyActualOilProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  dailyActualWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  dailyActualWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  dailyAssociatedGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  dailyNonAssociatedGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => FieldSchema.nullish()),
  executionType: z.lazy(() => TimeSeriesSchema.nullish()),
  fieldAllocationVolumeSource: z.lazy(() => TimeSeriesSchema.nullish()),
  fieldInjectionAllocationVolumeSource: z.lazy(() => TimeSeriesSchema.nullish()),
  gasInjectioAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  gasInjectionAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  gasProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  injectionWFExecutionType: z.lazy(() => TimeSeriesSchema.nullish()),
  nagProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  oilProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAssociatedGasAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMNonAssociatedGasAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMOilAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMRelativeFieldAssociatedGasVolumeError: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMRelativeFieldNonAssociatedGasVolumeError: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMRelativeFieldOilVolumeError: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMRelativeFieldWaterVolumeError: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMTotalWellsEstimatedAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMTotalWellsEstimatedNonAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMTotalWellsEstimatedOilVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMTotalWellsEstimatedWaterVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMWaterAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  relativeFieldGasVolumeError: z.lazy(() => TimeSeriesSchema.nullish()),
  relativeFieldWaterVolumeError: z.lazy(() => TimeSeriesSchema.nullish()),
  totalWellsGasInjectionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  totalWellsWaterInjectionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  waterInjectionAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  waterInjectionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  waterProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMAssociatedGasAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMNonAssociatedGasAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMOilAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMRelativeFieldAssociatedGasVolumeError: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMRelativeFieldNonAssociatedGasVolumeError: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMRelativeFieldOilVolumeError: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMRelativeFieldWaterVolumeError: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMTotalWellsEstimatedAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMTotalWellsEstimatedNonAssociatedGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMTotalWellsEstimatedOilVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMTotalWellsEstimatedWaterVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMWaterAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const StringReservoirInputsSchema: z.ZodObject<Properties<StringReservoirInputs>> = z.object({
  __typename: z.literal('String_Reservoir_Inputs').optional(),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  fieldName: z.lazy(() => FieldSchema.nullish()),
  reservoirName: z.lazy(() => ReservoirSchema.nullish()),
  stringReservoirInjectionAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  stringReservoirProductionAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const StringFluidCompositionAgentSchema: z.ZodObject<Properties<StringFluidCompositionAgent>> = z.object({
  __typename: z.literal('StringFluidComposition_Agent').optional(),
  c1: z.lazy(() => TimeSeriesSchema.nullish()),
  c2: z.lazy(() => TimeSeriesSchema.nullish()),
  c3: z.lazy(() => TimeSeriesSchema.nullish()),
  c6: z.lazy(() => TimeSeriesSchema.nullish()),
  cgr: z.lazy(() => TimeSeriesSchema.nullish()),
  co2: z.lazy(() => TimeSeriesSchema.nullish()),
  condensateGravity: z.lazy(() => TimeSeriesSchema.nullish()),
  fluidType: z.lazy(() => TimeSeriesSchema.nullish()),
  h2s: z.lazy(() => TimeSeriesSchema.nullish()),
  iC4: z.lazy(() => TimeSeriesSchema.nullish()),
  iC5: z.lazy(() => TimeSeriesSchema.nullish()),
  n2: z.lazy(() => TimeSeriesSchema.nullish()),
  nC4: z.lazy(() => TimeSeriesSchema.nullish()),
  nC5: z.lazy(() => TimeSeriesSchema.nullish()),
  specificGasGravity: z.lazy(() => TimeSeriesSchema.nullish()),
  waterSalinity: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  wgr: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const StringFluidCompositionSchema: z.ZodObject<Properties<StringFluidComposition>> = z.object({
  __typename: z.literal('StringFluidComposition').optional(),
  c1: z.lazy(() => TimeSeriesSchema.nullish()),
  c2: z.lazy(() => TimeSeriesSchema.nullish()),
  c3: z.lazy(() => TimeSeriesSchema.nullish()),
  c6: z.lazy(() => TimeSeriesSchema.nullish()),
  c7c10: z.lazy(() => TimeSeriesSchema.nullish()),
  c7c13: z.lazy(() => TimeSeriesSchema.nullish()),
  c7c14: z.lazy(() => TimeSeriesSchema.nullish()),
  c7c15: z.lazy(() => TimeSeriesSchema.nullish()),
  c7c16: z.lazy(() => TimeSeriesSchema.nullish()),
  c7c18: z.lazy(() => TimeSeriesSchema.nullish()),
  c11c16: z.lazy(() => TimeSeriesSchema.nullish()),
  c14c23: z.lazy(() => TimeSeriesSchema.nullish()),
  c14c28: z.lazy(() => TimeSeriesSchema.nullish()),
  c14plus: z.lazy(() => TimeSeriesSchema.nullish()),
  c15c25: z.lazy(() => TimeSeriesSchema.nullish()),
  c16c25: z.lazy(() => TimeSeriesSchema.nullish()),
  c16c26: z.lazy(() => TimeSeriesSchema.nullish()),
  c17c24: z.lazy(() => TimeSeriesSchema.nullish()),
  c17c25: z.lazy(() => TimeSeriesSchema.nullish()),
  c17c29: z.lazy(() => TimeSeriesSchema.nullish()),
  c17plus: z.lazy(() => TimeSeriesSchema.nullish()),
  c24c73: z.lazy(() => TimeSeriesSchema.nullish()),
  c25c80: z.lazy(() => TimeSeriesSchema.nullish()),
  c25plus: z.lazy(() => TimeSeriesSchema.nullish()),
  c26c80: z.lazy(() => TimeSeriesSchema.nullish()),
  c27c80: z.lazy(() => TimeSeriesSchema.nullish()),
  c28plus: z.lazy(() => TimeSeriesSchema.nullish()),
  c30c18: z.lazy(() => TimeSeriesSchema.nullish()),
  c30c80: z.lazy(() => TimeSeriesSchema.nullish()),
  c74c80: z.lazy(() => TimeSeriesSchema.nullish()),
  c74plus: z.lazy(() => TimeSeriesSchema.nullish()),
  c80plus: z.lazy(() => TimeSeriesSchema.nullish()),
  c81plus: z.lazy(() => TimeSeriesSchema.nullish()),
  cgr: z.lazy(() => TimeSeriesSchema.nullish()),
  co2: z.lazy(() => TimeSeriesSchema.nullish()),
  condensateGravity: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  fluidType: z.lazy(() => TimeSeriesSchema.nullish()),
  h2s: z.lazy(() => TimeSeriesSchema.nullish()),
  iC4: z.lazy(() => TimeSeriesSchema.nullish()),
  iC4plusnC4: z.lazy(() => TimeSeriesSchema.nullish()),
  iC5: z.lazy(() => TimeSeriesSchema.nullish()),
  iC5plusnC5: z.lazy(() => TimeSeriesSchema.nullish()),
  n2: z.lazy(() => TimeSeriesSchema.nullish()),
  nC4: z.lazy(() => TimeSeriesSchema.nullish()),
  nC5: z.lazy(() => TimeSeriesSchema.nullish()),
  specificGasGravity: z.lazy(() => TimeSeriesSchema.nullish()),
  waterSalinity: z.lazy(() => TimeSeriesSchema.nullish()),
  wgr: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const SeparatorInputsSchema: z.ZodObject<Properties<SeparatorInputs>> = z.object({
  __typename: z.literal('SeparatorInputs').optional(),
  entityName: z.lazy(() => EntitySchema.nullish()),
  separatorGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  separatorOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  separatorPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  separatorWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const SectorOutputsSchema: z.ZodObject<Properties<SectorOutputs>> = z.object({
  __typename: z.literal('SectorOutputs').optional(),
  downholeGasInjectionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeGasProductionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeOilProductionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeWaterInjectionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeWaterProductionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => SectorSchema.nullish()),
  field: z.lazy(() => FieldSchema.nullish()),
  giRate: z.lazy(() => TimeSeriesSchema.nullish()),
  giTargetRate: z.lazy(() => TimeSeriesSchema.nullish()),
  giTargetRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  mtdVRR: z.lazy(() => TimeSeriesSchema.nullish()),
  mtdVRRCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  pressureCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  regionPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoir: z.lazy(() => ReservoirSchema.nullish()),
  vrr: z.lazy(() => TimeSeriesSchema.nullish()),
  vrrCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveGi: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveGpNf: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveOpEsp: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveOpGl: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveOpNf: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveWi: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveGi: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveGpNf: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveOpEsp: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveOpGl: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveOpNf: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveWi: z.lazy(() => TimeSeriesSchema.nullish()),
  wiRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wiTargetRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wiTargetRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  ytdVRR: z.lazy(() => TimeSeriesSchema.nullish()),
  ytdVRRCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const SrmOutputsStringSchema: z.ZodObject<Properties<SrmOutputsString>> = z.object({
  __typename: z.literal('SRMOutputs_String').optional(),
  adHocOptimizedGasInjRateResCond: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimizedGasInjRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimizedGasRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimizedInjRateResCond: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimizedOilRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimizedProdRateResCond: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimizedWaterInjRateResCond: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimizedWaterInjRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimizedWaterRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocoptimizedBHFPGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocoptimizedChokeSizeGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocoptimizedESPFrequencyGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocoptimizedGasInjRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocoptimizedGasLiftRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocoptimizedGasRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocoptimizedOilRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocoptimizedWaterInjRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocoptimizedWaterRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  createdDate: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  executionBy: z.lazy(() => TimeSeriesSchema.nullish()),
  executionDate: z.lazy(() => TimeSeriesSchema.nullish()),
  isOfficial: z.lazy(() => TimeSeriesSchema.nullish()),
  lastUpdatedDate: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizeGasRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizeWaterRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedBHFPGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedChokeSizeGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedESPFrequencyGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedGasInjRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedGasInjRateResCond: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedGasInjRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedGasLiftRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedGasRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedInjRateResCond: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedOilRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedOilRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedProdRateResCond: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedWHP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedWaterInjRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedWaterInjRateResCond: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedWaterInjRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedWaterRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  scenario: z.lazy(() => TimeSeriesSchema.nullish()),
  scenaroID: z.lazy(() => TimeSeriesSchema.nullish()),
  wellType: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const SrmOutputsAllEntitiesSchema: z.ZodObject<Properties<SrmOutputsAllEntities>> = z.object({
  __typename: z.literal('SRMOutputs_All_Entities').optional(),
  createdDate: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => EntitySchema.nullish()),
  entityType: z.lazy(() => TimeSeriesSchema.nullish()),
  executionBy: z.lazy(() => TimeSeriesSchema.nullish()),
  executionDate: z.lazy(() => TimeSeriesSchema.nullish()),
  gasInjCapacity: z.lazy(() => TimeSeriesSchema.nullish()),
  isOfficial: z.lazy(() => TimeSeriesSchema.nullish()),
  lastUpdatedDate: z.lazy(() => TimeSeriesSchema.nullish()),
  oilRateQuota: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedCO2InjRateResCondSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedCO2InjRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedGasInjRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedGasInjRateResCondSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedGasInjRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedGasRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedGasRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedOilRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedOilRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedProdRateResCondSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedWaterInjRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedWaterInjRateResCondSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedWaterInjRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedWaterRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedWaterRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  scenario: z.lazy(() => TimeSeriesSchema.nullish()),
  scenaroID: z.lazy(() => TimeSeriesSchema.nullish()),
  vrrTarget: z.lazy(() => TimeSeriesSchema.nullish()),
  waterInjCapacity: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const SrmOutputSchema: z.ZodObject<Properties<SrmOutput>> = z.object({
  __typename: z.literal('SRMOutput').optional(),
  date: z.coerce.date().nullish(),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  executionBy: z.string().nullish(),
  executionDate: z.coerce.date().nullish(),
  optimizeGasRate: z.float32().nullish(),
  optimizedCO2InjRateResCondSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedCO2InjRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedOilRate: z.float32().nullish(),
  scenario: z.string().nullish(),
});

export const ReservoirOutputsAgentSchema: z.ZodObject<Properties<ReservoirOutputsAgent>> = z.object({
  __typename: z.literal('ReservoirOutputs_Agent').optional(),
  downholeGasInjectionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeGasProductionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeOilProductionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeWaterInjectionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeWaterProductionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  field: z.lazy(() => FieldSchema.nullish()),
  giRate: z.lazy(() => TimeSeriesSchema.nullish()),
  giTargetRate: z.lazy(() => TimeSeriesSchema.nullish()),
  giTargetRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  mtdVRR: z.lazy(() => TimeSeriesSchema.nullish()),
  mtdVRRCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  pressureCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  regionPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoir: z.lazy(() => ReservoirSchema.nullish()),
  vrr: z.lazy(() => TimeSeriesSchema.nullish()),
  vrrCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveGi: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveGpNf: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveOpEsp: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveOpGl: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveOpNf: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveWi: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveGi: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveGpNf: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveOpEsp: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveOpGl: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveOpNf: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveWi: z.lazy(() => TimeSeriesSchema.nullish()),
  wiRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wiTargetRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wiTargetRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  ytdVRR: z.lazy(() => TimeSeriesSchema.nullish()),
  ytdVRRCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const ReservoirOutputsSchema: z.ZodObject<Properties<ReservoirOutputs>> = z.object({
  __typename: z.literal('ReservoirOutputs').optional(),
  downholeGasInjectionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeGasProductionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeOilProductionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeWaterInjectionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  downholeWaterProductionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => ReservoirSchema.nullish()),
  field: z.lazy(() => FieldSchema.nullish()),
  giRate: z.lazy(() => TimeSeriesSchema.nullish()),
  giTargetRate: z.lazy(() => TimeSeriesSchema.nullish()),
  giTargetRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  mtdVRR: z.lazy(() => TimeSeriesSchema.nullish()),
  mtdVRRCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  pressureCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  regionPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  vrr: z.lazy(() => TimeSeriesSchema.nullish()),
  vrrCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveGi: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveGpNf: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveOpEsp: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveOpGl: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveOpNf: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveWi: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveGi: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveGpNf: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveOpEsp: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveOpGl: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveOpNf: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveWi: z.lazy(() => TimeSeriesSchema.nullish()),
  wiRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wiTargetRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wiTargetRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  ytdVRR: z.lazy(() => TimeSeriesSchema.nullish()),
  ytdVRRCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const ReservoirInputsAgentSchema: z.ZodObject<Properties<ReservoirInputsAgent>> = z.object({
  __typename: z.literal('ReservoirInputs_Agent').optional(),
  reservoir: z.lazy(() => ReservoirSchema.nullish()),
  reservoirInjectionAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirInjectionAllocationGasFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirInjectionAllocationOilFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirInjectionAllocationWaterFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirProductionAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirProductionAllocationGasFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirProductionAllocationOilFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirProductionAllocationWaterFactor: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const ReservoirInputsSchema: z.ZodObject<Properties<ReservoirInputs>> = z.object({
  __typename: z.literal('ReservoirInputs').optional(),
  entityName: z.lazy(() => ReservoirSchema.nullish()),
  reservoirInjectionAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirInjectionAllocationGasFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirInjectionAllocationOilFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirInjectionAllocationWaterFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirProductionAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirProductionAllocationGasFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirProductionAllocationOilFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirProductionAllocationWaterFactor: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const RateDiagnosticsStringAgentSchema: z.ZodObject<Properties<RateDiagnosticsStringAgent>> = z.object({
  __typename: z.literal('RateDiagnostics_String_Agent').optional(),
  chokeCdCalc: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeSizeCalc: z.lazy(() => TimeSeriesSchema.nullish()),
  grdAnalysisStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  qliqDelta: z.lazy(() => TimeSeriesSchema.nullish()),
  wellPerformance: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const PtsOutputsStringAgentSchema: z.ZodObject<Properties<PtsOutputsStringAgent>> = z.object({
  __typename: z.literal('PtsOutputs_String_Agent').optional(),
  cO2: z.lazy(() => TimeSeriesSchema.nullish()),
  calcWellTestGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  calcWellTestGORInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  calcWellTestTotalGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  composition: z.lazy(() => TimeSeriesSchema.nullish()),
  estGasLiftInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  fluidCompositionPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  freeCGRPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  freeGORPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  freeGORSC: z.lazy(() => TimeSeriesSchema.nullish()),
  h2S: z.lazy(() => TimeSeriesSchema.nullish()),
  n2: z.lazy(() => TimeSeriesSchema.nullish()),
  sampleDateTime: z.lazy(() => TimeSeriesSchema.nullish()),
  saturationPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  solutionCGR: z.lazy(() => TimeSeriesSchema.nullish()),
  solutionCGRPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  solutionGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  solutionGORPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  usedGasLiftInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  waterSalinity: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  wellTestEstimatedGLRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGORPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGorPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestLiquidRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilRatePtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestUsedGLRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWGRPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterCutPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterCutPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const PtsOutputsStringSchema: z.ZodObject<Properties<PtsOutputsString>> = z.object({
  __typename: z.literal('PtsOutputs_String').optional(),
  anchoringFluid: z.lazy(() => TimeSeriesSchema.nullish()),
  bGLPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  bOil: z.lazy(() => TimeSeriesSchema.nullish()),
  bOilRs: z.lazy(() => TimeSeriesSchema.nullish()),
  bgPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  blackOilPropModel: z.lazy(() => TimeSeriesSchema.nullish()),
  boPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  bwPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  cO2: z.lazy(() => TimeSeriesSchema.nullish()),
  cO2Rs: z.lazy(() => TimeSeriesSchema.nullish()),
  calcSaturationPress: z.lazy(() => TimeSeriesSchema.nullish()),
  calcTotalGORPvtRsPts2: z.lazy(() => TimeSeriesSchema.nullish()),
  calcWellTestGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  calcWellTestGORInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  calcWellTestTotalGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  cgrPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  composition: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  estGasLiftInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  fieldGLToleranceUpdate: z.lazy(() => TimeSeriesSchema.nullish()),
  fluidCompModelPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  fluidCompModelPtsRefFreeGas: z.lazy(() => TimeSeriesSchema.nullish()),
  fluidCompModelPtsRefResult: z.lazy(() => TimeSeriesSchema.nullish()),
  fluidCompModelWellTest: z.lazy(() => TimeSeriesSchema.nullish()),
  fluidCompositionPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  fluidCompositionPts1FreeGas: z.lazy(() => TimeSeriesSchema.nullish()),
  fluidProperties: z.lazy(() => TimeSeriesSchema.nullish()),
  freeCGRPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  freeGORPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  freeGORSC: z.lazy(() => TimeSeriesSchema.nullish()),
  gasDensityPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  gasDensityPts2: z.lazy(() => TimeSeriesSchema.nullish()),
  gasGravity: z.lazy(() => TimeSeriesSchema.nullish()),
  gasRatePVTRsPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  h2S: z.lazy(() => TimeSeriesSchema.nullish()),
  h2SRs: z.lazy(() => TimeSeriesSchema.nullish()),
  hydrateCurveTotalFluidPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  matchingMethod: z.lazy(() => TimeSeriesSchema.nullish()),
  modelRevisionExternalId: z.lazy(() => TimeSeriesSchema.nullish()),
  modelRevisionFileId: z.lazy(() => TimeSeriesSchema.nullish()),
  modelRevisionId: z.lazy(() => TimeSeriesSchema.nullish()),
  modelRevisionModelExternalId: z.lazy(() => TimeSeriesSchema.nullish()),
  n2: z.lazy(() => TimeSeriesSchema.nullish()),
  n2Rs: z.lazy(() => TimeSeriesSchema.nullish()),
  n2SRs: z.lazy(() => TimeSeriesSchema.nullish()),
  oilAPIPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  oilAPIPts2: z.lazy(() => TimeSeriesSchema.nullish()),
  oilDensityPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  oilDensityPts2: z.lazy(() => TimeSeriesSchema.nullish()),
  oilGravity: z.lazy(() => TimeSeriesSchema.nullish()),
  oilViscosity: z.lazy(() => TimeSeriesSchema.nullish()),
  oilViscosityRs: z.lazy(() => TimeSeriesSchema.nullish()),
  phaseEnvelopeConditionsModelPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  phaseEnvelopeConditionsModelPtsRefFreeGas: z.lazy(() => TimeSeriesSchema.nullish()),
  phaseEnvelopeConditionsModelPtsRefResult: z.lazy(() => TimeSeriesSchema.nullish()),
  phaseEnvelopeConditionsModelPtsRs: z.lazy(() => TimeSeriesSchema.nullish()),
  phaseEnvelopeConditionsModelWellTest: z.lazy(() => TimeSeriesSchema.nullish()),
  phaseEnvelopeRecordsModelPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  phaseEnvelopeRecordsModelPtsRefFreeGas: z.lazy(() => TimeSeriesSchema.nullish()),
  phaseEnvelopeRecordsModelPtsRefResult: z.lazy(() => TimeSeriesSchema.nullish()),
  phaseEnvelopeRecordsModelPtsRefRs: z.lazy(() => TimeSeriesSchema.nullish()),
  phaseEnvelopeRecordsModelWellTest: z.lazy(() => TimeSeriesSchema.nullish()),
  pvtInfo: z.string().nullish(),
  sampleComposition: z.lazy(() => TimeSeriesSchema.nullish()),
  sampleDateTime: z.lazy(() => TimeSeriesSchema.nullish()),
  saturationPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  saturationPressureRs: z.lazy(() => TimeSeriesSchema.nullish()),
  solutionCGR: z.lazy(() => TimeSeriesSchema.nullish()),
  solutionCGRPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  solutionGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  solutionGORPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  solutionGORRs: z.lazy(() => TimeSeriesSchema.nullish()),
  solutionGORRsPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  solutionGORRsPts1scfbbl: z.lazy(() => TimeSeriesSchema.nullish()),
  specificGasGravityRs: z.lazy(() => TimeSeriesSchema.nullish()),
  specificGravityGasPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  specificGravityGasPts2: z.lazy(() => TimeSeriesSchema.nullish()),
  specificGravityOilPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  specificGravityOilPts2: z.lazy(() => TimeSeriesSchema.nullish()),
  specificOilGravityRs: z.lazy(() => TimeSeriesSchema.nullish()),
  totalCGRPts2: z.lazy(() => TimeSeriesSchema.nullish()),
  totalGORPvtRsPts2: z.lazy(() => TimeSeriesSchema.nullish()),
  usedGasLiftInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  usedGasLiftInjectionRateLC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterDensityPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  waterDensityPts2: z.lazy(() => TimeSeriesSchema.nullish()),
  waterSalinity: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestCGRPts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestCGRPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestCGRPts2: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestCGRPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEstimatedGLRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGLMassFlowRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGLMassFlowRatePts2: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGORPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasMassFlowRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasMassFlowRatePts2: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasMassFlowRatePtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasRatePts2: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasRatePtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGorPts2: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGorPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestHCMassFlowRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestHCMassFlowRatePts2: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestHCMassFlowRatePtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestLiquidRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestLiquidRatePts2: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestLiquidRatePtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilMassFlowRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilMassFlowRatePts2: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilMassFlowRatePtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilRatePts2: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilRatePtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestSGVPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestSGVPts2: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestSOVPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestSOVPts2: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTotalMassFlowRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTotalMassFlowRatePts2: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTotalMassFlowRatePtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestUsedGLRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWGRPts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWGRPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWGRPts2: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWGRPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterCutPts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterCutPts2: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterCutPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterMassFlowRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterMassFlowRatePts2: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterMassFlowRatePtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterRatePts2: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterRatePtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const ProsperModelMetricsSchema: z.ZodObject<Properties<ProsperModelMetrics>> = z.object({
  __typename: z.literal('ProsperModelMetrics').optional(),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  field: z.lazy(() => FieldSchema.nullish()),
  modelAvailability: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const ProdplanStringReservoirSectorSchema: z.ZodObject<Properties<ProdplanStringReservoirSector>> = z.object({
  __typename: z.literal('Prodplan_String_Reservoir_Sector').optional(),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  fmoprContr: z.lazy(() => TimeSeriesSchema.nullish()),
  fmoprWater: z.lazy(() => TimeSeriesSchema.nullish()),
  giAllowableContr: z.lazy(() => TimeSeriesSchema.nullish()),
  giAllowableRate: z.lazy(() => TimeSeriesSchema.nullish()),
  giAvailableContr: z.lazy(() => TimeSeriesSchema.nullish()),
  giSubmittedMonth: z.lazy(() => TimeSeriesSchema.nullish()),
  giSustainableContr: z.lazy(() => TimeSeriesSchema.nullish()),
  giSustainableRate: z.lazy(() => TimeSeriesSchema.nullish()),
  giTechnicalRate: z.lazy(() => TimeSeriesSchema.nullish()),
  giWellAvailability: z.lazy(() => TimeSeriesSchema.nullish()),
  opBg: z.lazy(() => TimeSeriesSchema.nullish()),
  opBo: z.lazy(() => TimeSeriesSchema.nullish()),
  opBw: z.lazy(() => TimeSeriesSchema.nullish()),
  opRs: z.lazy(() => TimeSeriesSchema.nullish()),
  opSubmittedMonth: z.lazy(() => TimeSeriesSchema.nullish()),
  opVrrAdjustment: z.lazy(() => TimeSeriesSchema.nullish()),
  opWar: z.lazy(() => TimeSeriesSchema.nullish()),
  opWarVrr: z.lazy(() => TimeSeriesSchema.nullish()),
  opWpr: z.lazy(() => TimeSeriesSchema.nullish()),
  opWprFlowAssurance: z.lazy(() => TimeSeriesSchema.nullish()),
  opWprIntegrity: z.lazy(() => TimeSeriesSchema.nullish()),
  opWprManPress: z.lazy(() => TimeSeriesSchema.nullish()),
  opWsopr: z.lazy(() => TimeSeriesSchema.nullish()),
  opWtr: z.lazy(() => TimeSeriesSchema.nullish()),
  quotaContr: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirName: z.string().nullish(),
  sectorName: z.string().nullish(),
  wiAllowableContr: z.lazy(() => TimeSeriesSchema.nullish()),
  wiAllowableRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wiAvailableContr: z.lazy(() => TimeSeriesSchema.nullish()),
  wiSubmittedMonth: z.lazy(() => TimeSeriesSchema.nullish()),
  wiSustainableContr: z.lazy(() => TimeSeriesSchema.nullish()),
  wiSustainableRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wiTechnicalRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wiWellAvailability: z.lazy(() => TimeSeriesSchema.nullish()),
  wsoprTotalGas: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const ProdplanStringSchema: z.ZodObject<Properties<ProdplanString>> = z.object({
  __typename: z.literal('Prodplan_String').optional(),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  fmoprContr: z.lazy(() => TimeSeriesSchema.nullish()),
  fmoprWater: z.lazy(() => TimeSeriesSchema.nullish()),
  giAllowableContr: z.lazy(() => TimeSeriesSchema.nullish()),
  giAllowableRate: z.lazy(() => TimeSeriesSchema.nullish()),
  giAvailableContr: z.lazy(() => TimeSeriesSchema.nullish()),
  giSubmittedMonth: z.lazy(() => TimeSeriesSchema.nullish()),
  giSustainableContr: z.lazy(() => TimeSeriesSchema.nullish()),
  giSustainableRate: z.lazy(() => TimeSeriesSchema.nullish()),
  giTechnicalRate: z.lazy(() => TimeSeriesSchema.nullish()),
  giWellAvailability: z.lazy(() => TimeSeriesSchema.nullish()),
  opBg: z.lazy(() => TimeSeriesSchema.nullish()),
  opBo: z.lazy(() => TimeSeriesSchema.nullish()),
  opBw: z.lazy(() => TimeSeriesSchema.nullish()),
  opRs: z.lazy(() => TimeSeriesSchema.nullish()),
  opSubmittedMonth: z.lazy(() => TimeSeriesSchema.nullish()),
  opVrrAdjustment: z.lazy(() => TimeSeriesSchema.nullish()),
  opWar: z.lazy(() => TimeSeriesSchema.nullish()),
  opWarVrr: z.lazy(() => TimeSeriesSchema.nullish()),
  opWpr: z.lazy(() => TimeSeriesSchema.nullish()),
  opWprFlowAssurance: z.lazy(() => TimeSeriesSchema.nullish()),
  opWprIntegrity: z.lazy(() => TimeSeriesSchema.nullish()),
  opWprManPress: z.lazy(() => TimeSeriesSchema.nullish()),
  opWsopr: z.lazy(() => TimeSeriesSchema.nullish()),
  opWtr: z.lazy(() => TimeSeriesSchema.nullish()),
  quotaContr: z.lazy(() => TimeSeriesSchema.nullish()),
  wiAllowableContr: z.lazy(() => TimeSeriesSchema.nullish()),
  wiAllowableRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wiAvailableContr: z.lazy(() => TimeSeriesSchema.nullish()),
  wiSubmittedMonth: z.lazy(() => TimeSeriesSchema.nullish()),
  wiSustainableContr: z.lazy(() => TimeSeriesSchema.nullish()),
  wiSustainableRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wiTechnicalRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wiWellAvailability: z.lazy(() => TimeSeriesSchema.nullish()),
  wsoprTotalGas: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const PriorityRatesStringAgentSchema: z.ZodObject<Properties<PriorityRatesStringAgent>> = z.object({
  __typename: z.literal('PriorityRates_String_Agent').optional(),
  priorityFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityMethod: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const PvtAnalysisStringAgentSchema: z.ZodObject<Properties<PvtAnalysisStringAgent>> = z.object({
  __typename: z.literal('PVTAnalysis_String_Agent').optional(),
  salinity: z.lazy(() => TimeSeriesSchema.nullish()),
  sampleDate: z.lazy(() => TimeSeriesSchema.nullish()),
  sampleType: z.lazy(() => TimeSeriesSchema.nullish()),
  waterCut: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const PvtAnalysisStringSchema: z.ZodObject<Properties<PvtAnalysisString>> = z.object({
  __typename: z.literal('PVTAnalysis_String').optional(),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  salinity: z.lazy(() => TimeSeriesSchema.nullish()),
  sampleDate: z.lazy(() => TimeSeriesSchema.nullish()),
  sampleType: z.lazy(() => TimeSeriesSchema.nullish()),
  waterCut: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const OptimizedRatesSrmStringAgentSchema: z.ZodObject<Properties<OptimizedRatesSrmStringAgent>> = z.object({
  __typename: z.literal('OptimizedRates_SRM_String_Agent').optional(),
  executionDate: z.lazy(() => TimeSeriesSchema.nullish()),
  isOfficial: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizeGasRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizeWaterRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedBHFPGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedChokeSizeGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedESPFrequencyGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedGasInjRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedGasInjRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedGasLiftRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedGasRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedInjRateResCond: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedOilRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedOilRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedProdRateResCond: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedWHP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedWaterInjRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedWaterInjRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
  optimizedWaterRateGAP: z.lazy(() => TimeSeriesSchema.nullish()),
  scenario: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const OptimizedRatesNetworkStringAgentSchema: z.ZodObject<Properties<OptimizedRatesNetworkStringAgent>> =
  z.object({
    __typename: z.literal('OptimizedRates_Network_String_Agent').optional(),
    adHocOptimization1GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation1GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation1OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation1WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation2GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation2OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    fsoprGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    fsoprOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    fsoprWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    hydraulicGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    hydraulicOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    hydraulicWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    technicalGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    technicalOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    technicalWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    wellString: z.lazy(() => StringAssetSchema.nullish()),
  });

export const NetworkRiskOptimizationScenariosAgentSchema: z.ZodObject<
  Properties<NetworkRiskOptimizationScenariosAgent>
> = z.object({
  __typename: z.literal('NetworkRisk_OptimizationScenarios_Agent').optional(),
  aggregatedRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  asphalteneDTMax: z.lazy(() => TimeSeriesSchema.nullish()),
  asphalteneRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  corrosionRateMax: z.lazy(() => TimeSeriesSchema.nullish()),
  corrosionRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => EntitySchema.nullish()),
  erosionMax: z.lazy(() => TimeSeriesSchema.nullish()),
  erosionRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  evrMax: z.lazy(() => TimeSeriesSchema.nullish()),
  evrRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  hydrateDTMax: z.lazy(() => TimeSeriesSchema.nullish()),
  hydrateRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  network: z.lazy(() => NetworkSchema.nullish()),
  pe5StabilityMax: z.lazy(() => TimeSeriesSchema.nullish()),
  pe5StabilityRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  runID: z.lazy(() => TimeSeriesSchema.nullish()),
  scaleSIMax: z.lazy(() => TimeSeriesSchema.nullish()),
  scaleSIRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  scenarioName: z.string().nullish(),
  waxDTMax: z.lazy(() => TimeSeriesSchema.nullish()),
  waxRisk: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const NetworkRiskOptimizationScenariosSchema: z.ZodObject<Properties<NetworkRiskOptimizationScenarios>> =
  z.object({
    __typename: z.literal('NetworkRisk_OptimizationScenarios').optional(),
    aggregatedRisk: z.lazy(() => TimeSeriesSchema.nullish()),
    asphalteneDTMax: z.lazy(() => TimeSeriesSchema.nullish()),
    asphalteneRisk: z.lazy(() => TimeSeriesSchema.nullish()),
    corrosionRateMax: z.lazy(() => TimeSeriesSchema.nullish()),
    corrosionRisk: z.lazy(() => TimeSeriesSchema.nullish()),
    entityName: z.lazy(() => EntitySchema.nullish()),
    erosionMax: z.lazy(() => TimeSeriesSchema.nullish()),
    erosionRisk: z.lazy(() => TimeSeriesSchema.nullish()),
    evrMax: z.lazy(() => TimeSeriesSchema.nullish()),
    evrRisk: z.lazy(() => TimeSeriesSchema.nullish()),
    hydrateDTMax: z.lazy(() => TimeSeriesSchema.nullish()),
    hydrateRisk: z.lazy(() => TimeSeriesSchema.nullish()),
    network: z.lazy(() => NetworkSchema.nullish()),
    pe5StabilityMax: z.lazy(() => TimeSeriesSchema.nullish()),
    pe5StabilityRisk: z.lazy(() => TimeSeriesSchema.nullish()),
    runID: z.lazy(() => TimeSeriesSchema.nullish()),
    scaleSIMax: z.lazy(() => TimeSeriesSchema.nullish()),
    scaleSIRisk: z.lazy(() => TimeSeriesSchema.nullish()),
    scenarioName: z.string().nullish(),
    waxDTMax: z.lazy(() => TimeSeriesSchema.nullish()),
    waxRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  });

export const NetworkRiskAgentSchema: z.ZodObject<Properties<NetworkRiskAgent>> = z.object({
  __typename: z.literal('NetworkRisk_Agent').optional(),
  aggregatedRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  asphalteneDTMax: z.lazy(() => TimeSeriesSchema.nullish()),
  asphalteneRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  corrosionRateMax: z.lazy(() => TimeSeriesSchema.nullish()),
  corrosionRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => EntitySchema.nullish()),
  erosionMax: z.lazy(() => TimeSeriesSchema.nullish()),
  erosionRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  evrMax: z.lazy(() => TimeSeriesSchema.nullish()),
  evrRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  hydrateDTMax: z.lazy(() => TimeSeriesSchema.nullish()),
  hydrateRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  network: z.lazy(() => NetworkSchema.nullish()),
  pe5StabilityMax: z.lazy(() => TimeSeriesSchema.nullish()),
  pe5StabilityRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  scaleSIMax: z.lazy(() => TimeSeriesSchema.nullish()),
  scaleSIRisk: z.lazy(() => TimeSeriesSchema.nullish()),
  waxDTMax: z.lazy(() => TimeSeriesSchema.nullish()),
  waxRisk: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const NetworkRatesStringAgentSchema: z.ZodObject<Properties<NetworkRatesStringAgent>> = z.object({
  __typename: z.literal('NetworkRates_String_Agent').optional(),
  calculatedGasRateMatchIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedOilRateMatchIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWaterRateMatchIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellFBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellGasRateGI: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellWaterRateWI: z.lazy(() => TimeSeriesSchema.nullish()),
  formationWellGasOilRatio: z.lazy(() => TimeSeriesSchema.nullish()),
  gapWellName: z.string().nullish(),
  gasLiftInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverDifference: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverEstimatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverMeasuredOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const NetworkOutputsStringSchema: z.ZodObject<Properties<NetworkOutputsString>> = z.object({
  __typename: z.literal('NetworkOutputs_String').optional(),
  adHocOptimization1ChokeBeanSize: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization1ChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization1EspFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization1ExecutedBy: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization1FBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization1FWHP: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization1GasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization1GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization1OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization1OptimizedParameter: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization1Power: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization1RunID: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization1WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2ChokeBeanSize: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2ChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2EspFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2ExecutedBy: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2FBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2FWHP: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2GasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2OptimizedParameter: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2Power: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2RunID: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1ChokeBeanSize: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1ChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1EspFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1ExecutedBy: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1FBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1FWHP: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1GasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1OptimizedParameter: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1Power: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1RunID: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2ChokeBeanSize: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2ChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2EspFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2ExecutedBy: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2FBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2FWHP: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2GasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2OptimizedParameter: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2Power: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2RunID: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  asphalteneFlag_well: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedChokeBeanSize: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedChokeBeanSizeGI: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedChokeBeanSizeWI: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedEspFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedGasRateMatchIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedOilRateMatchIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedPower: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedPumpLquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWaterRateMatchIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellBHPGI: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellBHPWI: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellESPMotorLoad: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellFBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellFWHP: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellGasRateGI: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedWellWaterRateWI: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeDP: z.lazy(() => TimeSeriesSchema.nullish()),
  constraintFlag_well: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  espEfficiency: z.lazy(() => TimeSeriesSchema.nullish()),
  formationWellGasOilRatio: z.lazy(() => TimeSeriesSchema.nullish()),
  fsoprChokeBeanSize: z.lazy(() => TimeSeriesSchema.nullish()),
  fsoprChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  fsoprEspFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  fsoprFBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  fsoprFWHP: z.lazy(() => TimeSeriesSchema.nullish()),
  fsoprGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
  fsoprGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  fsoprOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  fsoprOptimizedParameter: z.lazy(() => TimeSeriesSchema.nullish()),
  fsoprPower: z.lazy(() => TimeSeriesSchema.nullish()),
  fsoprRunID: z.lazy(() => TimeSeriesSchema.nullish()),
  fsoprWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  gapOptimizedParameter: z.lazy(() => TimeSeriesSchema.nullish()),
  gapWellName: z.string().nullish(),
  gapWellNameHistorical: z.lazy(() => TimeSeriesSchema.nullish()),
  gasLiftInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  gasLiftInjectionPress: z.lazy(() => TimeSeriesSchema.nullish()),
  hydrateFlag_well: z.lazy(() => TimeSeriesSchema.nullish()),
  hydraulicChokeBeanSize: z.lazy(() => TimeSeriesSchema.nullish()),
  hydraulicChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  hydraulicEspFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  hydraulicFBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  hydraulicFWHP: z.lazy(() => TimeSeriesSchema.nullish()),
  hydraulicGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
  hydraulicGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  hydraulicOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  hydraulicOptimizedParameter: z.lazy(() => TimeSeriesSchema.nullish()),
  hydraulicPower: z.lazy(() => TimeSeriesSchema.nullish()),
  hydraulicRunID: z.lazy(() => TimeSeriesSchema.nullish()),
  hydraulicWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  pe5StabilityFlag_well: z.lazy(() => TimeSeriesSchema.nullish()),
  scaleFlag_well: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedChokeBeanSize: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedEspFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedFBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedFWHP: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedOptimizedParameter: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedPower: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedRunID: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  technicalChokeBeanSize: z.lazy(() => TimeSeriesSchema.nullish()),
  technicalChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  technicalEspFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  technicalFBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  technicalFWHP: z.lazy(() => TimeSeriesSchema.nullish()),
  technicalGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
  technicalGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  technicalOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  technicalOptimizedParameter: z.lazy(() => TimeSeriesSchema.nullish()),
  technicalPower: z.lazy(() => TimeSeriesSchema.nullish()),
  technicalRunID: z.lazy(() => TimeSeriesSchema.nullish()),
  technicalWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  waxFlag_well: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverDifference: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverEstimatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverMeasuredOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const NetworkOutputsFieldSchema: z.ZodObject<Properties<NetworkOutputsField>> = z.object({
  __typename: z.literal('NetworkOutputs_Field').optional(),
  adHocOptimization1ExecutedBy: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization1GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization1OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization1WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2ExecutedBy: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocOptimization2WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1ExecutedBy: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation1WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2ExecutedBy: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  adHocSimulation2WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calcualtedSeparatorGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedFlowLinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedJointCo2: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedJointGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedJointH2S: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedJointLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedJointN2: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedJointOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedJointPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedPressureMatchIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedSeparatorOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedSepratorWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedTotalGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedTotalGasRateGI: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedTotalLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedTotalLiquidRateWI: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedTotalOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedTotalWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  calculatedTotalWaterRateWI: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => FieldSchema.nullish()),
  estimatedFlowlineUnstableflowFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  estimatedFlowlineflowassuranceflag: z.lazy(() => TimeSeriesSchema.nullish()),
  fsoprGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  fsoprOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  fsoprWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  hydraulicGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  hydraulicOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  hydraulicWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedPower: z.lazy(() => TimeSeriesSchema.nullish()),
  systemOptimizedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  technicalGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  technicalOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  technicalWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverEstimatedTotalGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverEstimatedTotalLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverEstimatedTotalOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverEstimatedTotalWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverGasDeviation: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverGasDifference: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverGasFlowMatchIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverGasFlowMatchIndexTolerance: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverLiquidDifference: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverMeasuredTotalGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverMeasuredTotalLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverMeasuredTotalOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverMeasuredTotalWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverOilDeviation: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverOilDifference: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverOilFlowMatchIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverOilFlowMatchIndexTolerance: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverWaterDeviation: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverWaterDifference: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverWaterFlowMatchIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  wellSolverWaterFlowMatchIndexTolerance: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const NetworkInputsSchema: z.ZodObject<Properties<NetworkInputs>> = z.object({
  __typename: z.literal('NetworkInputs').optional(),
  asphalteneTable: z.lazy(() => TimeSeriesSchema.nullish()),
  availableGLRate: z.lazy(() => TimeSeriesSchema.nullish()),
  availablePower: z.lazy(() => TimeSeriesSchema.nullish()),
  capacityGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  capacityOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  capacityWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => NetworkSchema.nullish()),
  flowlineMaxCFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  flowlineMaxLinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  flowlineMaxMixtureVelocity: z.lazy(() => TimeSeriesSchema.nullish()),
  gasBarrelOfOilEquivalent: z.lazy(() => TimeSeriesSchema.nullish()),
  gasPrice: z.lazy(() => TimeSeriesSchema.nullish()),
  gasProcessingCost: z.lazy(() => TimeSeriesSchema.nullish()),
  hydrateTable: z.lazy(() => TimeSeriesSchema.nullish()),
  jointMaxCO2: z.lazy(() => TimeSeriesSchema.nullish()),
  jointMaxGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  jointMaxH2S: z.lazy(() => TimeSeriesSchema.nullish()),
  jointMaxLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  jointMaxN2: z.lazy(() => TimeSeriesSchema.nullish()),
  jointMaxOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  jointMaxPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  jointMinPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  liftCost: z.lazy(() => TimeSeriesSchema.nullish()),
  manifoldPress: z.lazy(() => TimeSeriesSchema.nullish()),
  manifoldTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  oilPrice: z.lazy(() => TimeSeriesSchema.nullish()),
  oilProcessingCost: z.lazy(() => TimeSeriesSchema.nullish()),
  plannedFacilityDowntime: z.lazy(() => TimeSeriesSchema.nullish()),
  scaleTable: z.lazy(() => TimeSeriesSchema.nullish()),
  separatorGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  separatorMaxGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  separatorMaxOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  separatorMaxWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  separatorOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  separatorPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  separatorTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  separatorWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  surfacePumpMaxLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  waterDisposalCost: z.lazy(() => TimeSeriesSchema.nullish()),
  waxTable: z.lazy(() => TimeSeriesSchema.nullish()),
  wellMaxGOR: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const MpfmOutputsSchema: z.ZodObject<Properties<MpfmOutputs>> = z.object({
  __typename: z.literal('MpfmOutputs').optional(),
  cgrLC: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAlarmsCode: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeMatchedliquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  comments: z.lazy(() => TimeSeriesSchema.nullish()),
  composition: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  espwear: z.lazy(() => TimeSeriesSchema.nullish()),
  fluidProperties: z.lazy(() => TimeSeriesSchema.nullish()),
  formationGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  gasDensityLC: z.lazy(() => TimeSeriesSchema.nullish()),
  gasDensitySC: z.lazy(() => TimeSeriesSchema.nullish()),
  gasMassFlowRateLC: z.lazy(() => TimeSeriesSchema.nullish()),
  gasMassFlowRateSC: z.lazy(() => TimeSeriesSchema.nullish()),
  gasVolumeFractionLC: z.lazy(() => TimeSeriesSchema.nullish()),
  glFcvOutletTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  glinjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  historicalAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  historicalAlarmsCode: z.lazy(() => TimeSeriesSchema.nullish()),
  liquidRateLc: z.lazy(() => TimeSeriesSchema.nullish()),
  liquidRateSc: z.lazy(() => TimeSeriesSchema.nullish()),
  modelAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  modelAlarmsCode: z.lazy(() => TimeSeriesSchema.nullish()),
  modelComposition: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedgasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedliquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedoilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedwaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMinStableRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelProductivityIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  modelReservoirModel: z.lazy(() => TimeSeriesSchema.nullish()),
  modelReservoirPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  modelStabilityFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  modelVlpModel: z.lazy(() => TimeSeriesSchema.nullish()),
  modelWellTestTimestamp: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmDifferentialPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmLinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmLineTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  oilDensityLC: z.lazy(() => TimeSeriesSchema.nullish()),
  oilDensitySC: z.lazy(() => TimeSeriesSchema.nullish()),
  oilMassFlowRateLC: z.lazy(() => TimeSeriesSchema.nullish()),
  oilMassFlowRateSC: z.lazy(() => TimeSeriesSchema.nullish()),
  oilVolumeFractionLC: z.lazy(() => TimeSeriesSchema.nullish()),
  ptsDateTime: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpDischargeTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpMotorTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpPower: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpVibration: z.lazy(() => TimeSeriesSchema.nullish()),
  pvtAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  sampleDateTime: z.lazy(() => TimeSeriesSchema.nullish()),
  stablePeriodEndDate: z.lazy(() => TimeSeriesSchema.nullish()),
  stablePeriodStartDate: z.lazy(() => TimeSeriesSchema.nullish()),
  validatedBy: z.lazy(() => TimeSeriesSchema.nullish()),
  waterDensityLC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterDensitySC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterMassFlowRateLC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterMassFlowRateSC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterVolumeFractionLC: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestApprovedAllocationFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestArtificialLiftType: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestBottomHolePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestBottomHoleTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestCGR: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestCasingHeadPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestCasingHeadTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestChokeSize: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestDuration: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEgorVendorStdGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEgorVendorStdOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEgorVendorStdWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEndDate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspMotorCurrent: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspMotorPower: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspMotorVoltage: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspPumpDischargePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspPumpFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspPumpIntakePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestEspPumpIntakeTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestFlowlinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestFlowlineTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasDensityInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasLiftVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasRateInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasRatePts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGlFlControlValvOutletPres: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGlFlControlValveInletPres: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGlFlControlValveInletTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGlInjectionChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGorInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestGorPts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestLiquidRatePts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestMpfmName: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilDensityInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilRateInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilRatePts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestStartDate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestStartDateDH: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestStringFunction: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTestMethod: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTestSeparatorLinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTestSeparatorLineTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTestType: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTestTypeDesc: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTotalGorStd: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTotalMassFlowRateGas: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTotalMassFlowRateOil: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestTotalMassFlowRateWater: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestValidationFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWGR: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterCut: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterCutInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterCutPts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterRateInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterRatePts: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWellheadPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellTestWellheadTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  wgrLC: z.lazy(() => TimeSeriesSchema.nullish()),
  wlrLC: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const MpfmInputsSchema: z.ZodObject<Properties<MpfmInputs>> = z.object({
  __typename: z.literal('MpfmInputs').optional(),
  entityName: z.lazy(() => MpfmSchema.nullish()),
  mpfmBSWMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmBSWMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmCalcCGRInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmCalcCGRStd: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmCalcGORInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmCalcGORStd: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmCalcGasDensityInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmCalcLiquidRateInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmCalcLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmCalcOilDensityInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmCalcWGRInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmCalcWGRStd: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmCalcWLRInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmCalcWaterDensityInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmCumGasVolInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmCumGasVolStd: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmCumLiquidVolInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmCumLiquidVolStd: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmDeltaPressMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmDeltaPressMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmDifferentialPress: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmFlagOnTest: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGORLCMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGORLCMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGORSTB: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGVFInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGVFMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGVFMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGasDensityInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGasDensityMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGasDensityMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGasDensityStd: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGasMassFlowInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGasMassFlowRateMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGasMassFlowRateMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGasMassFlowStd: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGasMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGasMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGasRateInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmLinePress: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmLineTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmLiqMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmLiqMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmLiquidRateInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmLiquidRateSTB: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmOVFMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmOVFMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmOilDensityInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmOilDensityMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmOilDensityMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmOilDensityStd: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmOilMassFlowInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmOilMassFlowRateMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmOilMassFlowRateMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmOilMassFlowStd: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmOilMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmOilMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmOilRateInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmOilVolFractionInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmPressMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmPressMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmTempMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmTempMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmTotalGORSCMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmTotalGORSCMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmTotalMassFlow: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWLRMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWLRMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWVFMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWVFMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWaterCutInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWaterCutSTB: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWaterDensityInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWaterDensityMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWaterDensityMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWaterDensityStd: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWaterMassFlowInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWaterMassFlowRateMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWaterMassFlowRateMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWaterMassFlowStd: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWaterMaxRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWaterMinRange: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWaterRateInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWaterSalinity: z.lazy(() => TimeSeriesSchema.nullish()),
  mpfmWaterVolumeFractionInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const ModelMatchedRatesStringAgentSchema: z.ZodObject<Properties<ModelMatchedRatesStringAgent>> = z.object({
  __typename: z.literal('ModelMatchedRates_String_Agent').optional(),
  cgrLC: z.lazy(() => TimeSeriesSchema.nullish()),
  cgrSC: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeMatchedgasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeMatchedliquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  gasRateSC: z.lazy(() => TimeSeriesSchema.nullish()),
  gorLC: z.lazy(() => TimeSeriesSchema.nullish()),
  historicalAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  modelAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedgasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedliquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedoilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  modelMatchedwaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  oilRateSC: z.lazy(() => TimeSeriesSchema.nullish()),
  pvtAlarms: z.lazy(() => TimeSeriesSchema.nullish()),
  totalGorSC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterCutLC: z.lazy(() => TimeSeriesSchema.nullish()),
  waterCutSC: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  wgrLC: z.lazy(() => TimeSeriesSchema.nullish()),
  wgrSC: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const MeasuredRatesWellTestStringAgentSchema: z.ZodObject<Properties<MeasuredRatesWellTestStringAgent>> =
  z.object({
    __typename: z.literal('MeasuredRates_WellTest_String_Agent').optional(),
    cgrLC: z.lazy(() => TimeSeriesSchema.nullish()),
    formationGOR: z.lazy(() => TimeSeriesSchema.nullish()),
    wellString: z.lazy(() => StringAssetSchema.nullish()),
    wellTestApprovedAllocationFlag: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestCGR: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestGOR: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestGorInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestGorPts: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestLiquidRatePts: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestStartDate: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestTotalGorStd: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestWGR: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestWaterCut: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestWaterCutInsitu: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestWaterCutPts: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
    wgrLC: z.lazy(() => TimeSeriesSchema.nullish()),
  });

export const MeasuredInjectionStringAgentSchema: z.ZodObject<Properties<MeasuredInjectionStringAgent>> = z.object({
  __typename: z.literal('MeasuredInjection_String_Agent').optional(),
  gasInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
  waterInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const ManifoldInputsSchema: z.ZodObject<Properties<ManifoldInputs>> = z.object({
  __typename: z.literal('ManifoldInputs').optional(),
  entityName: z.lazy(() => EntitySchema.nullish()),
  manifoldGasInjPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  manifoldGasInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
  manifoldGasInjTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  manifoldWaterInjPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  manifoldWaterInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
  manifoldWaterInjTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const LocationInputsSchema: z.ZodObject<Properties<LocationInputs>> = z.object({
  __typename: z.literal('LocationInputs').optional(),
  entityName: z.lazy(() => LocationSchema.nullish()),
  flowLinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  waterHeaderPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  waterHeaderTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const LiftTypeParameterStringSchema: z.ZodObject<Properties<LiftTypeParameterString>> = z.object({
  __typename: z.literal('LiftTypeParameter_String').optional(),
  amorphousFeS: z.lazy(() => TimeSeriesSchema.nullish()),
  amorphousSilica: z.lazy(() => TimeSeriesSchema.nullish()),
  anhydrite: z.lazy(() => TimeSeriesSchema.nullish()),
  asphalteneMaxLimit: z.float32().nullish(),
  asphalteneMinLimit: z.float32().nullish(),
  asphalteneRelativeWT: z.float32().nullish(),
  asphalteneRisk: z.boolean().nullish(),
  baCO3: z.lazy(() => TimeSeriesSchema.nullish()),
  barite: z.lazy(() => TimeSeriesSchema.nullish()),
  caF2: z.lazy(() => TimeSeriesSchema.nullish()),
  caOH2Portlandite: z.lazy(() => TimeSeriesSchema.nullish()),
  calcite: z.lazy(() => TimeSeriesSchema.nullish()),
  calestite: z.lazy(() => TimeSeriesSchema.nullish()),
  chrysotile: z.lazy(() => TimeSeriesSchema.nullish()),
  corrosionMaxLimit: z.float32().nullish(),
  corrosionMinLimit: z.float32().nullish(),
  corrosionRelativeWT: z.float32().nullish(),
  diopside: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  erosionMaxLimit: z.float32().nullish(),
  erosionMinLimit: z.float32().nullish(),
  erosionRelativeWT: z.float32().nullish(),
  espMaxDischargePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxDischargePressure_active: z.boolean().nullish(),
  espMaxFluidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxFluidRate_active: z.boolean().nullish(),
  espMaxFreeGasInPump: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxFreeGasInPump_active: z.boolean().nullish(),
  espMaxHead: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxHead_active: z.boolean().nullish(),
  espMaxMotorAmps: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxMotorAmps_active: z.boolean().nullish(),
  espMaxMotorEfficiency: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxMotorEfficiency_active: z.boolean().nullish(),
  espMaxMotorLoadPermissible: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxMotorLoadPermissible_active: z.boolean().nullish(),
  espMaxMotorPwr: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxMotorPwr_active: z.boolean().nullish(),
  espMaxMotorSpeed_InductorType: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxMotorSpeed_InductorType_active: z.boolean().nullish(),
  espMaxMotorSpeed_PmmType: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxMotorSpeed_PmmType_active: z.boolean().nullish(),
  espMaxMotorTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxMotorTemp_active: z.boolean().nullish(),
  espMaxPumpDeltaTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxPumpDeltaTemp_active: z.boolean().nullish(),
  espMaxPumpFluidVelocity: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxPumpFluidVelocity_active: z.boolean().nullish(),
  espMaxPwrAvail_Generated: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxPwrAvail_Generated_active: z.boolean().nullish(),
  espMaxSurfaceKva: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxSurfaceKva_active: z.boolean().nullish(),
  espMaxTrqOnShaft: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxTrqOnShaft_active: z.boolean().nullish(),
  espMaxVoltageDropAlongCable: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxVoltageDropAlongCable_active: z.boolean().nullish(),
  espMinFluidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  espMinFluidRate_active: z.boolean().nullish(),
  espMinIntakePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  espMinIntakePressure_active: z.boolean().nullish(),
  espMinIntakeTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  espMinIntakeTemperature_active: z.boolean().nullish(),
  espMinMotorPowerFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  espMinMotorPowerFactor_active: z.boolean().nullish(),
  espMinPumpFluidVelocity: z.lazy(() => TimeSeriesSchema.nullish()),
  espMinPumpFluidVelocity_active: z.boolean().nullish(),
  feCO3: z.lazy(() => TimeSeriesSchema.nullish()),
  fluidVelocity: z.boolean().nullish(),
  fourCalcOptions: z.lazy(() => TimeSeriesSchema.nullish()),
  glMaxCasingHeadPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  glMaxCasingHeadPressure_active: z.boolean().nullish(),
  glMaxLiftChokeDeltaTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  glMaxLiftChokeDeltaTemp_active: z.boolean().nullish(),
  glMaxManifoldPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  glMaxManifoldPressure_active: z.boolean().nullish(),
  glMaxWellHeadTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  glMaxWellHeadTemp_active: z.boolean().nullish(),
  glMinBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  glMinBHP_active: z.boolean().nullish(),
  glMinCasingHeadPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  glMinCasingHeadPressure_active: z.boolean().nullish(),
  glMinManifolddPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  glMinManifolddPressure_active: z.boolean().nullish(),
  glMinWellHeadPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  glMinWellHeadPressure_active: z.boolean().nullish(),
  greenalite: z.lazy(() => TimeSeriesSchema.nullish()),
  gypsum: z.lazy(() => TimeSeriesSchema.nullish()),
  halite: z.lazy(() => TimeSeriesSchema.nullish()),
  hemihydrate: z.lazy(() => TimeSeriesSchema.nullish()),
  hydrateMaxLimit: z.float32().nullish(),
  hydrateMinLimit: z.float32().nullish(),
  hydrateRelativeWT: z.float32().nullish(),
  hydrateRisk: z.boolean().nullish(),
  liquidLoadingMaxLimit: z.float32().nullish(),
  liquidLoadingMinLimit: z.float32().nullish(),
  liquidLoadingRelativeWT: z.float32().nullish(),
  mackinawite: z.lazy(() => TimeSeriesSchema.nullish()),
  maxGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  maxGOR_active: z.boolean().nullish(),
  maxLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  maxLiquidRate_active: z.boolean().nullish(),
  maxOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  maxOilRate_active: z.boolean().nullish(),
  maxWellHeadPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  maxWellHeadPressure_active: z.boolean().nullish(),
  mgOH2Brucite: z.lazy(() => TimeSeriesSchema.nullish()),
  pbSGalena: z.lazy(() => TimeSeriesSchema.nullish()),
  pe5MaxLimit: z.float32().nullish(),
  pe5MinLimit: z.float32().nullish(),
  pe5RelativeWT: z.float32().nullish(),
  pe5StabilityCriteria: z.boolean().nullish(),
  quartz: z.lazy(() => TimeSeriesSchema.nullish()),
  srCO3: z.lazy(() => TimeSeriesSchema.nullish()),
  troilitePyrrhotite: z.lazy(() => TimeSeriesSchema.nullish()),
  usePhTuning: z.lazy(() => TimeSeriesSchema.nullish()),
  waxMaxLimit: z.float32().nullish(),
  waxMinLimit: z.float32().nullish(),
  waxRelativeWT: z.float32().nullish(),
  waxRisk: z.boolean().nullish(),
  znCO3: z.lazy(() => TimeSeriesSchema.nullish()),
  znS: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const InjectionPerformanceStringAgentSchema: z.ZodObject<Properties<InjectionPerformanceStringAgent>> = z.object(
  {
    __typename: z.literal('InjectionPerformance_String_Agent').optional(),
    cumulativeGasInjPress: z.lazy(() => TimeSeriesSchema.nullish()),
    cumulativeGasInjVol: z.lazy(() => TimeSeriesSchema.nullish()),
    cumulativeWaterInjPress: z.lazy(() => TimeSeriesSchema.nullish()),
    cumulativeWaterInjVol: z.lazy(() => TimeSeriesSchema.nullish()),
    downholeGasInjectionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
    downholeWaterInjectionVolume: z.lazy(() => TimeSeriesSchema.nullish()),
    giBHP: z.lazy(() => TimeSeriesSchema.nullish()),
    giRate: z.lazy(() => TimeSeriesSchema.nullish()),
    giTargetRate: z.lazy(() => TimeSeriesSchema.nullish()),
    giTechnicalRate: z.lazy(() => TimeSeriesSchema.nullish()),
    giWHP: z.lazy(() => TimeSeriesSchema.nullish()),
    hallInterpretation: z.lazy(() => TimeSeriesSchema.nullish()),
    hallLine: z.lazy(() => TimeSeriesSchema.nullish()),
    injectionEfficiency: z.lazy(() => TimeSeriesSchema.nullish()),
    injectionEfficiencyFlag: z.lazy(() => TimeSeriesSchema.nullish()),
    injectionEfficiencyRank: z.lazy(() => TimeSeriesSchema.nullish()),
    injectivityIndex: z.lazy(() => TimeSeriesSchema.nullish()),
    wellString: z.lazy(() => StringAssetSchema.nullish()),
    wiBHP: z.lazy(() => TimeSeriesSchema.nullish()),
    wiRate: z.lazy(() => TimeSeriesSchema.nullish()),
    wiTargetRate: z.lazy(() => TimeSeriesSchema.nullish()),
    wiTechnicalRate: z.lazy(() => TimeSeriesSchema.nullish()),
    wiWHP: z.lazy(() => TimeSeriesSchema.nullish()),
  },
);

export const InactiveStringSchema: z.ZodObject<Properties<InactiveString>> = z.object({
  __typename: z.literal('Inactive_String').optional(),
  actionDate: z.lazy(() => TimeSeriesSchema.nullish()),
  actionStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  categoryCode: z.lazy(() => TimeSeriesSchema.nullish()),
  downtimeStartDate: z.lazy(() => TimeSeriesSchema.nullish()),
  duration: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  expectedRate: z.lazy(() => TimeSeriesSchema.nullish()),
  inactiveCategory: z.lazy(() => TimeSeriesSchema.nullish()),
  problemName: z.lazy(() => TimeSeriesSchema.nullish()),
  stringStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  stringStatusAll: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const InactiveStringAgentSchema: z.ZodObject<Properties<InactiveStringAgent>> = z.object({
  __typename: z.literal('InactiveString_Agent').optional(),
  downtimeStartDate: z.lazy(() => TimeSeriesSchema.nullish()),
  inactiveCategory: z.lazy(() => TimeSeriesSchema.nullish()),
  stringStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const GasLiftMeasurementsStringAgentSchema: z.ZodObject<Properties<GasLiftMeasurementsStringAgent>> = z.object({
  __typename: z.literal('GasLiftMeasurements_String_Agent').optional(),
  annulusPress: z.lazy(() => TimeSeriesSchema.nullish()),
  bottomHolePress: z.lazy(() => TimeSeriesSchema.nullish()),
  bottomHoleTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  casingHeadPress: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeSize: z.lazy(() => TimeSeriesSchema.nullish()),
  flowLinePress: z.lazy(() => TimeSeriesSchema.nullish()),
  flowLineTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  gasLiftFlowCVInletPress: z.lazy(() => TimeSeriesSchema.nullish()),
  gasLiftFlowCVSize: z.lazy(() => TimeSeriesSchema.nullish()),
  gasLiftInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
  gasLiftInjTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  liftType: z.lazy(() => TimeSeriesSchema.nullish()),
  wellHeadPress: z.lazy(() => TimeSeriesSchema.nullish()),
  wellHeadTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const GasLiftLimitsStringAgentSchema: z.ZodObject<Properties<GasLiftLimitsStringAgent>> = z.object({
  __typename: z.literal('GasLiftLimits_String_Agent').optional(),
  asphalteneRisk: z.boolean().nullish(),
  fluidVelocity: z.boolean().nullish(),
  glMaxCasingHeadPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  glMaxCasingHeadPressure_active: z.boolean().nullish(),
  glMaxLiftChokeDeltaTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  glMaxManifoldPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  glMaxWellHeadTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  glMinBHP: z.lazy(() => TimeSeriesSchema.nullish()),
  glMinCasingHeadPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  glMinCasingHeadPressure_active: z.boolean().nullish(),
  glMinManifolddPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  glMinWellHeadPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  hydrateRisk: z.boolean().nullish(),
  maxGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  maxLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  maxOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  maxWellHeadPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  pe5StabilityCriteria: z.boolean().nullish(),
  waxRisk: z.boolean().nullish(),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const GasLiftCalculationsStringAgentSchema: z.ZodObject<Properties<GasLiftCalculationsStringAgent>> = z.object({
  __typename: z.literal('GasLiftCalculations_String_Agent').optional(),
  glChokeCdCalc: z.lazy(() => TimeSeriesSchema.nullish()),
  glChokeSizeCalc: z.lazy(() => TimeSeriesSchema.nullish()),
  glirAllocated: z.lazy(() => TimeSeriesSchema.nullish()),
  glirChokeEquation: z.lazy(() => TimeSeriesSchema.nullish()),
  glirMeasured: z.lazy(() => TimeSeriesSchema.nullish()),
  glirNetworkSimulation: z.lazy(() => TimeSeriesSchema.nullish()),
  glirSelected: z.lazy(() => TimeSeriesSchema.nullish()),
  glirSelectedType: z.lazy(() => TimeSeriesSchema.nullish()),
  glqlAnalysisStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const FluidCompositionSchema: z.ZodObject<Properties<FluidComposition>> = z.object({
  __typename: z.literal('FluidComposition').optional(),
  c1: z.lazy(() => TimeSeriesSchema.nullish()),
  c2: z.lazy(() => TimeSeriesSchema.nullish()),
  c3: z.lazy(() => TimeSeriesSchema.nullish()),
  c6: z.lazy(() => TimeSeriesSchema.nullish()),
  c7c14: z.lazy(() => TimeSeriesSchema.nullish()),
  c15c25: z.lazy(() => TimeSeriesSchema.nullish()),
  c26c80: z.lazy(() => TimeSeriesSchema.nullish()),
  cgr: z.lazy(() => TimeSeriesSchema.nullish()),
  co2: z.lazy(() => TimeSeriesSchema.nullish()),
  condensateGravity: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => FieldSchema.nullish()),
  h2s: z.lazy(() => TimeSeriesSchema.nullish()),
  iC4: z.lazy(() => TimeSeriesSchema.nullish()),
  iC5: z.lazy(() => TimeSeriesSchema.nullish()),
  n2: z.lazy(() => TimeSeriesSchema.nullish()),
  nC4: z.lazy(() => TimeSeriesSchema.nullish()),
  nC5: z.lazy(() => TimeSeriesSchema.nullish()),
  specificGasGravity: z.lazy(() => TimeSeriesSchema.nullish()),
  waterSalinity: z.lazy(() => TimeSeriesSchema.nullish()),
  wgr: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const FlowlineOutputsNetworkAgentSchema: z.ZodObject<Properties<FlowlineOutputsNetworkAgent>> = z.object({
  __typename: z.literal('FlowlineOutputs_Network_Agent').optional(),
  connectedManifoldIdGI: z.lazy(() => TimeSeriesSchema.nullish()),
  connectedManifoldIdWI: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => EntitySchema.nullish()),
  estimatedFlowlineDeltaP: z.lazy(() => TimeSeriesSchema.nullish()),
  network: z.lazy(() => NetworkSchema.nullish()),
  nmvAboveErosionVelocity: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvAsphalteneFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvBottleneckFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvCFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvCgr: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvConnectedManifoldId: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvDp: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvErosionVelocity: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvErosionalVelocityFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvFlowlinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvGlr: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvGor: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvHydrateFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvInjectionGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvInjectionWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvMeasuredFlowlinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvMixtureVelocity: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvPe5StabilityFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvPressureMatchIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvPressureMatchIndexFLP: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvScaleFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvUnstableFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvViolatingConstraintsFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvWaterCut: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvWaxFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  nmvWgr: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const FieldOutputsSchema: z.ZodObject<Properties<FieldOutputs>> = z.object({
  __typename: z.literal('FieldOutputs').optional(),
  entityName: z.lazy(() => FieldSchema.nullish()),
  wellsActiveGi: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveGpNf: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveOpEsp: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveOpGl: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveOpNf: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveWAG: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsActiveWi: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveGi: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveGpNf: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveOpEsp: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveOpGl: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveOpNf: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInActiveWi: z.lazy(() => TimeSeriesSchema.nullish()),
  wellsInactiveWAG: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const FieldInputsSchema: z.ZodObject<Properties<FieldInputs>> = z.object({
  __typename: z.literal('FieldInputs').optional(),
  actualGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  actualGasInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  actualGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  actualGasProductionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  actualOilProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  actualOilProductionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  actualWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  actualWaterInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  actualWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  actualWaterProductionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  ambientTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  associatedGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  associatedGasProductionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => FieldSchema.nullish()),
  nonASRGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  nonASRGasInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  nonAssociatedGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  nonAssociatedGasProductionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialOilProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetOilProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const EventsStringSchema: z.ZodObject<Properties<EventsString>> = z.object({
  __typename: z.literal('Events_String').optional(),
  bottomholePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  bottomholeTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  casingPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  currentStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  eventReason: z.lazy(() => TimeSeriesSchema.nullish()),
  eventStartDateTime: z.lazy(() => TimeSeriesSchema.nullish()),
  statusCode: z.lazy(() => TimeSeriesSchema.nullish()),
  wellheadPressure: z.lazy(() => TimeSeriesSchema.nullish()),
  wellheadTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const EstimatedRatesStringAgentSchema: z.ZodObject<Properties<EstimatedRatesStringAgent>> = z.object({
  __typename: z.literal('EstimatedRates_String_Agent').optional(),
  chokeAnalysisFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAnalysisGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAnalysisLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAnalysisOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAnalysisStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  chokeAnalysisWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  curveAnalysisFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  curveAnalysisGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  curveAnalysisLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  curveAnalysisOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  curveAnalysisWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  dataAnalysisFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  dataAnalysisGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  dataAnalysisLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  dataAnalysisOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  dataAnalysisWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  iprAnalysisFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  iprAnalysisGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  iprAnalysisLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  iprAnalysisOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  iprAnalysisWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  pressureSource: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityMethod: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  priorityWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirPressureDatum: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirPressureMidPerforation: z.lazy(() => TimeSeriesSchema.nullish()),
  systemAnalysisFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  systemAnalysisGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  systemAnalysisLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  systemAnalysisOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  systemAnalysisStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  systemAnalysisWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  vlpAnalysisFbhp: z.lazy(() => TimeSeriesSchema.nullish()),
  vlpAnalysisGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  vlpAnalysisLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  vlpAnalysisOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  vlpAnalysisWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const EspMeasurementsStringAgentSchema: z.ZodObject<Properties<EspMeasurementsStringAgent>> = z.object({
  __typename: z.literal('ESPMeasurements_String_Agent').optional(),
  bottomHolePress: z.lazy(() => TimeSeriesSchema.nullish()),
  bottomHoleTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  liftType: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpCurrent: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpDischargePress: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpDischargeTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpIntakePress: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpIntakeTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpMotorTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpVibration: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpVoltage: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const EspLimitsStringAgentSchema: z.ZodObject<Properties<EspLimitsStringAgent>> = z.object({
  __typename: z.literal('ESPLimits_String_Agent').optional(),
  asphalteneRisk: z.boolean().nullish(),
  espMaxDischargePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxFluidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxFreeGasInPump: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxHead: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxMotorAmps: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxMotorAmps_active: z.boolean().nullish(),
  espMaxMotorPwr: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxMotorTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  espMaxMotorTemp_active: z.boolean().nullish(),
  espMaxPumpDeltaTemp: z.lazy(() => TimeSeriesSchema.nullish()),
  espMinFluidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  espMinIntakePressure: z.lazy(() => TimeSeriesSchema.nullish()),
  espMinIntakePressure_active: z.boolean().nullish(),
  fluidVelocity: z.boolean().nullish(),
  hydrateRisk: z.boolean().nullish(),
  maxGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  maxLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
  maxOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  pe5StabilityCriteria: z.boolean().nullish(),
  waxRisk: z.boolean().nullish(),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const EspCalculationsStringAgentSchema: z.ZodObject<Properties<EspCalculationsStringAgent>> = z.object({
  __typename: z.literal('ESPCalculations_String_Agent').optional(),
  espqlAnalysisStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  motorEfficiency: z.lazy(() => TimeSeriesSchema.nullish()),
  motorLoad: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpAvgRate: z.lazy(() => TimeSeriesSchema.nullish()),
  pumpHead: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const DataDrivenRatesStringAgentSchema: z.ZodObject<Properties<DataDrivenRatesStringAgent>> = z.object({
  __typename: z.literal('DataDrivenRates_String_Agent').optional(),
  dataDrivenGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  dataDrivenLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  dataDrivenOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  dataDrivenWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
  giBHPCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  giTargetRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  giTechnicalRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  giWHPCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  wiBHPCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  wiTargetRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  wiTechnicalRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  wiWHPCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const DailyRollupOutputWellSchema: z.ZodObject<Properties<DailyRollupOutputWell>> = z.object({
  __typename: z.literal('DailyRollupOutput_Well').optional(),
  dayAllocInjGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjGasInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjWaterInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedGas: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedOil: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedWater: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => WellSchema.nullish()),
  potentialGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialOilProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetOilproduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const DailyRollupOutputReservoirSchema: z.ZodObject<Properties<DailyRollupOutputReservoir>> = z.object({
  __typename: z.literal('DailyRollupOutput_Reservoir').optional(),
  dayAllocInjGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjGasInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjWaterInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedGas: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedOil: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedWater: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => ReservoirSchema.nullish()),
  potentialGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialOilProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetOilproduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const DailyRollupOutputLocationSchema: z.ZodObject<Properties<DailyRollupOutputLocation>> = z.object({
  __typename: z.literal('DailyRollupOutput_Location').optional(),
  dayAllocInjGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjGasInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjWaterInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedGas: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedOil: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedWater: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => LocationSchema.nullish()),
  potentialGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialOilProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetOilproduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const DailyRollupOutputFieldSchema: z.ZodObject<Properties<DailyRollupOutputField>> = z.object({
  __typename: z.literal('DailyRollupOutput_Field').optional(),
  dayAllocInjGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjGasInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjWaterInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedGas: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedOil: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedWater: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => FieldSchema.nullish()),
  potentialGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialOilProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetOilproduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const DailyRollupOutputCompanySchema: z.ZodObject<Properties<DailyRollupOutputCompany>> = z.object({
  __typename: z.literal('DailyRollupOutput_Company').optional(),
  dayAllocInjGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjGasInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjWaterInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedGas: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedOil: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedWater: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => CompanySchema.nullish()),
  potentialGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialOilProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetOilproduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const DailyRollupOutputAssetSchema: z.ZodObject<Properties<DailyRollupOutputAsset>> = z.object({
  __typename: z.literal('DailyRollupOutput_Asset').optional(),
  dayAllocInjGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjGasInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjWaterInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedGas: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedOil: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedWater: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => AssetSchema.nullish()),
  potentialGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialOilProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetOilproduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const DailyRollupFieldAgentSchema: z.ZodObject<Properties<DailyRollupFieldAgent>> = z.object({
  __typename: z.literal('DailyRollupField_Agent').optional(),
  dayAllocInjGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjGasInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocInjWaterInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedGas: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedOil: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedWater: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  fieldName: z.lazy(() => FieldSchema.nullish()),
  potentialGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialOilProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  potentialWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetGasProduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetOilproduction: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
  targetWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const AllocationOutputStringSchema: z.ZodObject<Properties<AllocationOutputString>> = z.object({
  __typename: z.literal('AllocationOutput_String').optional(),
  allocInjActiveHours: z.lazy(() => TimeSeriesSchema.nullish()),
  allocProdActiveHours: z.lazy(() => TimeSeriesSchema.nullish()),
  allocatedGasInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
  allocatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  allocatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  allocatedWaterInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
  allocatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
});

export const AllocationFactorsFieldAgentSchema: z.ZodObject<Properties<AllocationFactorsFieldAgent>> = z.object({
  __typename: z.literal('AllocationFactors_Field_Agent').optional(),
  field: z.lazy(() => FieldSchema.nullish()),
  gasInjectionAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAssociatedGasAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMNonAssociatedGasAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMOilAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMWaterAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  waterInjectionAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMAssociatedGasAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMNonAssociatedGasAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMOilAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMWaterAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const AllocatedRatesVfmStringAgentSchema: z.ZodObject<Properties<AllocatedRatesVfmStringAgent>> = z.object({
  __typename: z.literal('AllocatedRates_VFM_String_Agent').optional(),
  averageGasInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  averageWaterInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
  oilProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAverageAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAverageNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMAverageWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMDataSourceFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMEstimatedWellOilVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  preferredVFMEstimatedWellWaterVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmChokeAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmDataDrivenAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmESPAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmIPRAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmPreferredMethodAssociatedGasAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmPreferredMethodNonAssociatedGasAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmPreferredMethodOilAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmPreferredMethodWaterAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmSystemAnalysisAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmVLPAverageOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmWeightedAverageAssociatedGasAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmWeightedAverageMethodOilAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmWeightedAverageNonAssociatedGasAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
  vfmWeightedAverageWaterAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageDataSourceFlag: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMEstimatedWellOilVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
  weightedAverageVFMWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
  wellUptime: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const AllocatedRatesRealtimeStringAgentSchema: z.ZodObject<Properties<AllocatedRatesRealtimeStringAgent>> =
  z.object({
    __typename: z.literal('AllocatedRates_Realtime_String_Agent').optional(),
    allocInjActiveHours: z.lazy(() => TimeSeriesSchema.nullish()),
    allocProdActiveHours: z.lazy(() => TimeSeriesSchema.nullish()),
    allocatedGasInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
    allocatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    allocatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    allocatedWaterInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
    allocatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    wellString: z.lazy(() => StringAssetSchema.nullish()),
  });

export const AllocatedRatesDailyStringAgentSchema: z.ZodObject<Properties<AllocatedRatesDailyStringAgent>> = z.object({
  __typename: z.literal('AllocatedRates_Daily_String_Agent').optional(),
  dayAllocProdActiveHours: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedGas: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedOil: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedWater: z.lazy(() => TimeSeriesSchema.nullish()),
  monthAllocProdActiveDays: z.lazy(() => TimeSeriesSchema.nullish()),
  monthAllocProdAllocatedGas: z.lazy(() => TimeSeriesSchema.nullish()),
  monthAllocProdAllocatedOil: z.lazy(() => TimeSeriesSchema.nullish()),
  monthAllocProdAllocatedWater: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const AllocatedPropertiesStringSchema: z.ZodObject<Properties<AllocatedPropertiesString>> = z.object({
  __typename: z.literal('AllocatedProperties_String').optional(),
  dayAllocProdActiveHours: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedGas: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedOil: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdAllocatedWater: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdFlowDirection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdProdMethod: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdProdMode: z.lazy(() => TimeSeriesSchema.nullish()),
  dayAllocProdStringFunction: z.lazy(() => TimeSeriesSchema.nullish()),
  dayGPAllocVolActiveHours: z.lazy(() => TimeSeriesSchema.nullish()),
  dayGPAllocVolAllocatedGas: z.lazy(() => TimeSeriesSchema.nullish()),
  dayGPAllocVolFlowDirection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayGPAllocVolProdMethod: z.lazy(() => TimeSeriesSchema.nullish()),
  dayGPAllocVolProdMode: z.lazy(() => TimeSeriesSchema.nullish()),
  dayGPAllocVolStringFunction: z.lazy(() => TimeSeriesSchema.nullish()),
  dayGasInjActiveHours: z.lazy(() => TimeSeriesSchema.nullish()),
  dayGasInjFlowDirection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayGasInjGasInjVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  dayGasInjMaterialType: z.lazy(() => TimeSeriesSchema.nullish()),
  dayGasInjProdMode: z.lazy(() => TimeSeriesSchema.nullish()),
  dayGasInjStringFunction: z.lazy(() => TimeSeriesSchema.nullish()),
  dayWaterInjActiveHours: z.lazy(() => TimeSeriesSchema.nullish()),
  dayWaterInjFlowDirection: z.lazy(() => TimeSeriesSchema.nullish()),
  dayWaterInjMaterialType: z.lazy(() => TimeSeriesSchema.nullish()),
  dayWaterInjProdMode: z.lazy(() => TimeSeriesSchema.nullish()),
  dayWaterInjStringFunction: z.lazy(() => TimeSeriesSchema.nullish()),
  dayWaterInjWaterInjVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  monthAllocProdActiveDays: z.lazy(() => TimeSeriesSchema.nullish()),
  monthAllocProdAllocatedGas: z.lazy(() => TimeSeriesSchema.nullish()),
  monthAllocProdAllocatedOil: z.lazy(() => TimeSeriesSchema.nullish()),
  monthAllocProdAllocatedWater: z.lazy(() => TimeSeriesSchema.nullish()),
  monthAllocProdFlowDirection: z.lazy(() => TimeSeriesSchema.nullish()),
  monthAllocProdProdMethod: z.lazy(() => TimeSeriesSchema.nullish()),
  monthAllocProdStringFunction: z.lazy(() => TimeSeriesSchema.nullish()),
  monthGPAllocVolActiveHours: z.lazy(() => TimeSeriesSchema.nullish()),
  monthGPAllocVolAllocatedGas: z.lazy(() => TimeSeriesSchema.nullish()),
  monthGPAllocVolFlowDirection: z.lazy(() => TimeSeriesSchema.nullish()),
  monthGPAllocVolProdMethod: z.lazy(() => TimeSeriesSchema.nullish()),
  monthGPAllocVolProdMode: z.lazy(() => TimeSeriesSchema.nullish()),
  monthGPAllocVolStringFunction: z.lazy(() => TimeSeriesSchema.nullish()),
  monthGasInjActiveDays: z.lazy(() => TimeSeriesSchema.nullish()),
  monthGasInjFlowDirection: z.lazy(() => TimeSeriesSchema.nullish()),
  monthGasInjGasInjVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  monthGasInjMaterialType: z.lazy(() => TimeSeriesSchema.nullish()),
  monthGasInjProdMode: z.lazy(() => TimeSeriesSchema.nullish()),
  monthGasInjStringFunction: z.lazy(() => TimeSeriesSchema.nullish()),
  monthWaterInjActiveDays: z.lazy(() => TimeSeriesSchema.nullish()),
  monthWaterInjFlowDirection: z.lazy(() => TimeSeriesSchema.nullish()),
  monthWaterInjMaterialType: z.lazy(() => TimeSeriesSchema.nullish()),
  monthWaterInjProdMode: z.lazy(() => TimeSeriesSchema.nullish()),
  monthWaterInjStringFunction: z.lazy(() => TimeSeriesSchema.nullish()),
  monthWaterInjWaterInjVolume: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const AllocatedInjectionStringAgentSchema: z.ZodObject<Properties<AllocatedInjectionStringAgent>> = z.object({
  __typename: z.literal('AllocatedInjection_String_Agent').optional(),
  dayGasInjActiveHours: z.lazy(() => TimeSeriesSchema.nullish()),
  dayGasInjGasInjVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  dayWaterInjActiveHours: z.lazy(() => TimeSeriesSchema.nullish()),
  dayWaterInjWaterInjVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  monthGasInjActiveDays: z.lazy(() => TimeSeriesSchema.nullish()),
  monthGasInjGasInjVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  monthWaterInjActiveDays: z.lazy(() => TimeSeriesSchema.nullish()),
  monthWaterInjWaterInjVolume: z.lazy(() => TimeSeriesSchema.nullish()),
  wellString: z.lazy(() => StringAssetSchema.nullish()),
});

export const AlarmDefinitionSchema: z.ZodObject<Properties<AlarmDefinition>> = z.object({
  __typename: z.literal('AlarmDefinition').optional(),
  alarmCategory: z.string().nullish(),
  alarmCounterToTicket: z.number().nullish(),
  alarmCriticality: z.string().nullish(),
  alarmDataSource: z.string().nullish(),
  alarmDescription: z.string().nullish(),
  alarmMessage: z.string().nullish(),
  alarmMsgParameter: z.string().nullish(),
  alarmName: z.string().nullish(),
  alarmPriority: z.string().nullish(),
  alarmType: z.string().nullish(),
  alarmTypeCategory: z.string().nullish(),
  alarmTypeSubCategory: z.string().nullish(),
  alarmUnifiedCode: z.string().nullish(),
  isAlarmTicket: z.string().nullish(),
  subCategory: z.string().nullish(),
  subWorkflowName: z.string().nullish(),
  ticketAsset: z.string().nullish(),
  ticketAssignedGroup: z.string().nullish(),
  ticketAssignedTo: z.string().nullish(),
  ticketDept: z.string().nullish(),
  ticketRecommedation: z.string().nullish(),
  workflowCode: z.string().nullish(),
  workflowName: z.string().nullish(),
});

export const WfAlarmsSchema: z.ZodObject<Properties<WfAlarms>> = z.object({
  __typename: z.literal('WfAlarms').optional(),
  additionalInformation: z.json().nullish(),
  alarmCode: z.lazy(() => AlarmDefinitionSchema.nullish()),
  alarmCounter: z.number(),
  alarmFlags: z.string().nullish(),
  customWorkflowAlarmMessage: z.string(),
  endDateTime: z.coerce.date(),
  entityExternalId: z.string(),
  entityName: z.string(),
  entityType: z.string(),
  markAsRead: z.json().nullish(),
  operationType: z.string().nullish(),
  relatedEntity: z.string().nullish(),
  relatedEntityExternalId: z.string().nullish(),
  removeAlaramForUser: z.json().nullish(),
  ssWorkflowAlarmMessage: z.string().nullish(),
  startDateTime: z.coerce.date(),
  ticketId: z.string().nullish(),
});
